// Hulk Form
const FormID = $('[data-vatform]').data('vat-form-id');
const accessToken = $('[data-vatform]').data('vat-form-access-token');

// GRAPHQL
var productsForFilter=[];
function FetchData(query,callback) {
  fetch(endpoint,   {
    'async': true,
    'crossDomain': true,
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': gl_token,
      'Content-Type': 'application/graphql',
    },
    body:  query
  }).then(res => res.json())
  .then(data => {
    callback(data)
  });
}

function FetchDataWithVariables(queryData,variablesData,callback) {
  fetch(endpoint,   {
    'async': true,
    'crossDomain': true,
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': gl_token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify ({query:queryData,variables:variablesData})
  }).then(res => res.json())
  .then(data => {
    callback(data)
  });
}

function _getMetaProducts(ids,callback) {
  FetchData(`query {
    nodes(ids: ${JSON.stringify(ids)}) {
    ...on Product {
      id
            metafields (identifiers: [ 
   {namespace: "accentuate", key: "overlay"} 
  ]){           
        value
        key
        namespace
      }
    }
  }}`,function(_data) {      
    callback.apply(_data);
  });
}
// prevent load spr.js
if (document.getElementsByClassName('template-product').length==0) {
  const insertBeforeElementBackup = Element.prototype.insertBefore
  Element.prototype.insertBefore= function(...args) {   
    if(!args[0].outerHTML || (args[0].outerHTML && args[0].outerHTML.indexOf("spr.js") ==-1))        
    return insertBeforeElementBackup.apply(this,args)
  }
}

// RESIZE FUNCTION
var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
    _initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// COOKIES
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

// Format Money
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------

// Filters
function _initResize() {
  initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply-button').off('click');
  //$('.filter-sort__title').off('click');
  $(document).off('click.resize');
  //$('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  //$('.filter-sort__list').css('display','');
  //$('.filter-sort').off('click');

  // Filters Mobile/Tablet
  if ($(window).width() < 1365) {
    // Filters - Open
    $('.filter-refine').on('click', function () {
      $('.filter').toggleClass('filter--active');
      $('.filters__container').removeClass('filters__container--sticky');
      $('.filter-overlay').addClass('filter-overlay--active');
      $('html').addClass('no-scroll');
      return false;
    });

    // Filter - Close
    $('.filter-overlay, .filter__close, .filter__apply-button').on('click', function () {
      $('.filter').removeClass('filter--active');
      $('.filter-overlay').removeClass('filter-overlay--active');
      $('html').removeClass('no-scroll');
      return false;
    });
  }

  previousScroll = 0;
  headerOrgOffset = 0;
  if ($(window).width() > 1365) {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28;
  } else {
    if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top;
  }
  
};
// Filters All
$(document).ready(function() {
  loadswatches();
  _initFilter();
});

function _initFilter() {
  // Filter - Accordion
  $('.filter__title').off('click keydown').on('click keydown', function (e) {
    if (e.type === 'click' || e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation(); // Prevents double triggering

      var $this = $(this);
      var $list = $this.next('.filter__list');

      // Toggle active class and ARIA attributes
      if ($list.hasClass('filter__list--active')) {
        $list.removeClass('filter__list--active').slideUp(150);
        $this.removeClass('filter__title--active').attr('aria-expanded', 'false');
      } else {
        // Close other open lists
        $this.closest('.filter__group').siblings().find('.filter__list').removeClass('filter__list--active').slideUp(150);
        $this.closest('.filter__group').siblings().find('.filter__title').removeClass('filter__title--active').attr('aria-expanded', 'false');

        // Open the clicked list
        $list.addClass('filter__list--active').slideDown(150);
        $this.addClass('filter__title--active').attr('aria-expanded', 'true');
      }
    }
  });
}

// Header Sticky
var previousScroll = 0;
var headerOrgOffset = 0;
var isPageLoad = true; // Flag to track if it's the initial page load

if ($('.header').length > 0) {
  headerOrgOffset = $('.header').offset().top;
}

// Run after the page has fully loaded
$(window).on('load', function () {
  setTimeout(() => {
    isPageLoad = false; // Allow sticky behavior after a short delay
  }, 500); // Adjust delay as needed
});

$(window).scroll(function () {
  if ($('.header').length > 0) {
    var currentScroll = $(this).scrollTop();

    if (!isPageLoad) { // Prevent sticky behavior on page load
      if (currentScroll > headerOrgOffset) {
        if (currentScroll > previousScroll) {
          $('html:not(".no-scroll") .header').removeClass('header--sticky');
        } else {
          $('html:not(".no-scroll") .header').addClass('header--sticky');
        }
      } else {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
      }
    }
    previousScroll = currentScroll;
  }
});

// Klaviyo subscribe popup trigger
document.addEventListener('DOMContentLoaded', () => {
  const hashTrigger = window.location.hash.split('?')[0].split('&')[0];
  if (hashTrigger !== '#subscribe') return;

  const formId = document.documentElement.getAttribute('data-klaviyo-form-id');
  if (!formId || !formId.trim()) return;

  window._klOnsite = window._klOnsite || [];
  window._klOnsite.push(['openForm', formId.trim()]);
});

// Collection Filter Actions Sticky/Stuck
document.addEventListener('DOMContentLoaded', () => {
  const filters = document.querySelector('.filters__actions');
  if (!filters) return;

  // Create a sentinel above the filters
  const sentinel = document.createElement('div');
  filters.parentNode.insertBefore(sentinel, filters);

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting) {
        filters.classList.add('stuck');
      } else {
        filters.classList.remove('stuck');
      }
    },
    { threshold: 0 }
  );

  observer.observe(sentinel);
});

// Reduced popular filters
$(document).ready(function() {
  document.querySelectorAll('a.collection__popular-filter').forEach(el => {
    if (el.textContent.includes('Reduced')) {
      el.classList.add('collection__popular-filter--reduced');
    }
  });
});

// Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle').click(function () {
    $('.header-search__form').toggleClass('header-search__form--visible');
    $('.site-container').toggleClass('site-container--blackout');
    $('.header-search__input').focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
    }
  });
});       

// Footer Accordions
$(document).ready(function() { 
  function handleAccordion() {
    if ($(window).width() <= 599) {
      $('.footer-content__accordion-header')
        .off('click keydown')
        .on('click keydown', function (event) {
          if (event.type === 'click' || event.key === 'Enter') {
            const isExpanded = $(this).attr('aria-expanded') === 'true';
            $(this).attr('aria-expanded', !isExpanded);
            $(this).toggleClass('footer-content__accordion-header--shown');
            $(this).parent().find('.footer-content__accordion-content').slideToggle(200);
          }
        });
    } else {
      // Remove event listeners on larger screens
      $('.footer-content__accordion-header').off('click keydown').attr('aria-expanded', 'true');
    }
  }
  handleAccordion(); // Run on page load
  let lastWidth = $(window).width();
  $(window).resize(function() {
    let currentWidth = $(window).width();
    // Only re-run the function if crossing the 600px breakpoint
    if ((lastWidth <= 599 && currentWidth >= 600) || (lastWidth >= 600 && currentWidth <= 599)) {
      handleAccordion();
    }
    lastWidth = currentWidth; // Update last width
  });
});

// Nav Mega Hover
$(".nav__mega .nav__sub-menu").css('display', 'grid').hide();
$(".nav__mega .nav__sub-menu--reduced").css('display', 'block').hide();
$(".nav__single .nav__sub-menu").css('display', 'block').hide();
$(".nav__dropdown").on("mouseenter", function (e) {
  if (window.innerWidth > 1199) {
    $('.nav-overlay').stop(!0, !0).delay(125).fadeIn(200);
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(125).fadeIn(200);
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(125).fadeIn(200);
  }
});
$(".nav__dropdown").on("mouseleave", function (e) {
  if (window.innerWidth > 1199) {
    $('.nav-overlay').stop(!0, !0).delay(125).fadeOut(200);
    $(this).children(".nav__sub-menu").stop(!0, !0).delay(125).fadeOut(200);
    $(this).children(".nav__link").children("span").stop(!0, !0).delay(125).fadeOut(200);
  }
});

// Keyboard interaction - only open on Enter
$(".nav__dropdown .nav__link").on("keydown", function (e) {
  if (e.key === "Enter") {
    const $submenu = $(this).closest(".nav__dropdown").children(".nav__sub-menu");
    if ($submenu.is(":visible")) {
      $submenu.stop(true, true).fadeOut(200); // Close if already open
      $('.nav-overlay').stop(true, true).fadeOut(200);
    } else {
      $submenu.stop(true, true).fadeIn(200); // Open if closed
      $('.nav-overlay').stop(true, true).fadeIn(200);
    }
    e.preventDefault(); // Prevent default Enter behavior
  }
});

// Close dropdown on Escape
$(document).on("keydown", function (e) {
  if (e.key === "Escape") {
    $(".nav__sub-menu").stop(true, true).fadeOut(200);
    $('.nav-overlay').stop(true, true).fadeOut(200);
  }
})

// Finance Popup - Paypal
$('.product-finance__learn--paypal').on('click', function () {
  $('.product-finance-popup--paypal').addClass('product-finance-popup--active');
  $('html').addClass('noscroll-finance-popup');
});

// Finance Popup - Close
$('.product-finance-popup__close').on('click', function () {
  $('.product-finance-popup').removeClass('product-finance-popup--active');
  $('html').removeClass('noscroll-finance-popup');
});

$(document).mouseup(function(e) {
  var container = $(".product-finance-popup *");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.product-finance-popup--active').removeClass('product-finance-popup--active');
    $('html').removeClass('noscroll-finance-popup');
  }
});

// Account Tabs
$('.account .tab').on('click', function () {
  var tab_id = $(this).attr('data-tab');
  $('.account__tab').removeClass('account__tab--active');
  $('.account__content').hide();
  $(this).addClass('account__tab--active');
  $("#"+tab_id).show();
});

// Mobile Nav
$(document).ready(function() { 

  // Clone 
  $('.nav__sub-menu').each(function(){
    $(this).clone().addClass('nav__sub-menu--cloned').insertAfter(".header-nav").wrapInner("<div class='nav__sub-menu__wrap'></div>");
  });

  // Open & Close Nav (Mobile) - Click Function
  $('.header-mobile').off('click').on('click', function () {
    $(this).toggleClass('header-mobile--active');
    $('.header-nav').toggle();
    $('.header-nav').toggleClass('header-nav--active');
    $('html').toggleClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').toggle();
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

  // Close Nav (Mobile) - Click Function
  $('.mobile-nav-overlay').off('click').on('click', function () {
    $('.header-mobile').removeClass('header-mobile--active');
    $('.header-nav').hide();
    $('.header-nav').removeClass('header-nav--active');
    $('html').removeClass('no-scroll-mobile-nav');
    $('.mobile-nav-overlay').hide();
    $('.nav').removeClass('nav--hidden');
    $('.nav__sub-menu--cloned').removeClass('nav__sub-menu--active');
  });

  // Open Sub Menu - Click Function
  $('.nav__dropdown .nav__link').off('click').on('click', function (event) {
    if ($(window).width() < 1200) {
      event.preventDefault();
    }
    $('.nav__sub-sub-menu').hide();
    var id = $(this).attr('id');
    $('.nav__sub-menu').each(function(){
      var dataid = $(this).attr('data-id');
      if(id == dataid) {
        $(this).addClass('nav__sub-menu--active');
      }
    });
    $('.nav').addClass('nav--hidden');
  });

  // Sub Menu Accordion
  $('.nav__sub-menu__link--mega').off('click').on('click', function (event) {
    if ($(window).width() < 1200) {
      event.preventDefault();
      //$(this).next().slideToggle(200);
      if($(this).hasClass('active')) {
        $('.nav__sub-menu__link--mega').next().slideUp(200);
        $('.nav__sub-menu__link--mega').removeClass('active');
        $(this).children('.nav__chevrons').removeClass('nav__chevrons--active');
      } else {
        $('.nav__sub-menu__link--mega').removeClass('active');
        $('.nav__sub-menu__link--mega').next().slideUp(200);
        $('.nav__sub-menu__link--mega').children('.nav__chevrons').removeClass('nav__chevrons--active');
        $(this).next().slideDown(200);
        $(this).addClass('active');
        $(this).children('.nav__chevrons').addClass('nav__chevrons--active');
      }
    }
  });

  // Back Button - Click Function
  $('.nav__sub-menu__back').off('click').on('click', function () {
    $('.nav__sub-menu').removeClass('nav__sub-menu--active');
    $('.nav').removeClass('nav--hidden');
  });

});

// Swatches
function initSwatches() {
  if (window.swatches!=undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');

    if ($(window).width() > 599) {
    $('.swatches__col').hover(      
      function(){
        if ($(this).closest('[data-group-col]').length>0) {
          let _id=$(this).data('product-id');
          let _h=window.swatches.filter(function (e) { return (e.id  == _id )});
          if (_h.length>0) {                                                      
            showSwatchData(this,_h[0]);
          }
          else  {
            //swatch data not exist - need get firstly
            let el=this;
            var _handle;
            if (productsForFilter.length==0) {
              _handle=$(this).attr('href').replace('/products/','');
            }
            else {
              _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
            }
            if (_handle!=undefined) {
              getSwatchData(_handle,function(h) {
                showSwatchData(el,this);
              });
            }
          }
        }
      },function(){
        if ($(this).closest('[data-group-col]').length>0) {
          let _id=$(this).parent().find("[class*='--current']").closest('a').data('product-id');
          let _h=window.swatches.filter(function (e) { return (e.id  ==  _id )});
          if (_h.length>0) {                                                      
            showSwatchData(this,_h[0]);
          }
        }
      });
    } else {
      $('.swatches__col').on('click',function(e) {
        if ($(this).closest('[data-group-col]').length>0) {
          if ( $('div',this).hasClass('swatches__swatch--current')) return true;
          e.preventDefault();
          $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
          $('div',this).addClass('swatches__swatch--current');
          const _id=$(this).data('product-id');
          const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
          if (_h.length>0) {                                                      
            showSwatchData(this,_h[0]);
          }
          else  {
            //swatch data not exist - need get firstly
            const el=this;
            var _handle;
            if (productsForFilter.length==0) {
              _handle=$(this).attr('href').replace('/products/','');
            }
            else {
              _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
            }
            if (_handle!=undefined) {
              getSwatchData(_handle,function(h) {
                showSwatchData(el,this);
              });
            }
          }
          return false;
        }
      });
    }
  }
}

function getSwatchData(_handle,callback) {     
  $.ajax({
    method    : 'GET',
    url       : document.location.origin+"/products/"+_handle+"/?view=swatch",        
    success: function (data) {
      var _d=data.replace(/\n/g,'').replace(/,}/g,'}');   
      window.swatches=window.swatches || [];
      const h=JSON.parse(_d);
      window.swatches.push(h);
      callback.apply(h);
    }
  });
}
function showSwatchData(el,h) {
  var item=$(el).closest('.product-card');
  var title_parts = h.title.split(" - ");
  var title_first_part = title_parts[0];
  item.find('.product-card__image').attr("src", h.image);
  item.find('.product-card__image').attr("srcset", "");
  item.find('.product-card__title').text(h.title);
  item.find('.product-card__sku span').text(h.sku);
  item.find('.product-card__price-current').text(h.price);
  item.find('.product-card__price').removeClass('product-card__price--on-sale');
  item.find('.product-card__price').addClass(h.onsale);
  item.find('.product-card__price-compare').text(h.pricecompare);
  item.find('.product-card__price-saving').html(h.saving);
  item.find('.product-card__overlays').replaceWith(h.overlays); 
}

// Run Functions
function _checkafterLoadEvents() {
  window.afterLoadWithEvents.forEach(x=> {
    if (x.evt && !$(x.el).is(document)) {
      if ( x.evt==arguments[0].type && $(x.el).is(arguments[0].target)) {
        $(x.el).off(x.evt+'.'+x.f)
        if (typeof(x.f)=='function') {
          setTimeout(x.f,0);
        } else {
          window[x.f].apply();
        }
        window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
      }
    } else {
      if (typeof(x.f)=='function') {
        setTimeout(x.f,0);
      }
      else {
        window[x.f].apply();
      }
      window.afterLoadWithEvents.splice(window.afterLoadWithEvents.indexOf(x),1);  
    } 
  });
  if (window.afterLoadWithEvents.length==0) {
    $(window).off('scroll.afterLoad');
  }
}
function loadswatches(ismissed) {
  if (ismissed!==true) {
  //product detail group swatch    
  $('[data-group]').each(function() {
    let el=$(this);
    $.ajax({
        method    : 'GET',
        url       : document.location.origin+"/collections/all/product-group-code-"+$(this).data('group')+"/?view=product-swatch",        
        success: function (data) {
          if (data!='' && $(data).length>1) {
            el.empty().append(data);
            $('[data-group]').find('[href="'+document.location.pathname+'"] .swatches__swatch').addClass('swatches__swatch--current');
          }
          else {
            el.remove();
            $('.product-swatches').hide();
          }
        }
      });
    });
  }
  let sEl=$('[data-group-col]');    
  if (ismissed!==true) {
    sEl=$('[data-group-col]:not(:has(.swatches__col))');
  }      
  if (sEl.length>0) {
     let tags=[];
      sEl.each(function() {
      const t='Product Group Code|'+$(this).data('group-col');
      if (!tags.includes(t)) tags.push(t);    
    });
    renderSwatchAndOverlay(tags,function() {
      sEl.each(function() {
        let overlayHtml='';
        let htmlItems=[];
        let _tag=$(this).data('group-col');
        let _productsForTag=_productsForTags.filter(p=>p.tag==_tag);        
        let _id=$(this).data('group-col-id');
        if (_productsForTag.length==0) {                  
             _productsForTags.push({
                tag:_tag,
                products:_productsData.filter(p=>p.GroupCode==_tag)
             });
            _productsForTag=_productsForTags.filter(p=>p.tag==_tag);
          }
          if (_productsForTag.length>0){   
            const assetUrl=document.location.origin+"/cdn/shop/files/";
            _productsForTag[0].products.sort((a, b) => {
              if (a.id == _id) return -1;  // current item goes first
              if (b.id == _id) return 1;   // current item goes first
              return 0;  // maintain original order for other items
            }).forEach(p=>{                    
            let current='';
            let colcurrent='';
            if (_id==p.id){
              current="swatches__swatch--current"; 
              colcurrent="swatches__col--current";         
              overlayHtml=p.overlay;
            }
            if (p.swatchImage) {
              htmlItems.push(_swatchSettings.itemImage.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{image}}',assetUrl+p.swatchImage).replaceAll('{{name}}',p.swatchName).replace('{{current}}',current).replace('{{colcurrent}}',colcurrent));
            } else {
              htmlItems.push(_swatchSettings.item.replace('{{id}}',p.id).replace('{{url}}',p.handle).replace('{{color}}',p.swatchColor).replaceAll('{{name}}',p.swatchName).replace('{{current}}',current).replace('{{colcurrent}}',colcurrent));
            }
          });
          let _html=$(_swatchSettings.template.replace('{{items}}',htmlItems.join('')));
          if (htmlItems.length>4) {
            console.log();
            _html.append('<a aria-label="More Colours" class="product-card__swatch-more tool-tip__zone" href="'+$(this).closest('.product-card').find('.product-card__image-link').attr('href')+'"><i class="fas fa-plus"></i><div class="tool-tip tool-tip--swatch"><div class="tool-tip__label">More Colours</div></div></a>');
          }          
            if (htmlItems.length>1) {
              _html.attr('data-group-col',_tag);
              _html.attr('data-group-col-id',_id);
              $(this).replaceWith(_html);
            }
            else {
              $(this).remove();
            }
            //$(this).closest('.product-card').find('.product-card__image-link .product-card__overlays').remove();
            //$(this).closest('.product-card').find('.product-card__image-link').append(overlayHtml);
         }
      });
      window.swatches=[];
      if (!window.location.href.includes("pages/compare")) { 
        initSwatches();
      }
    });
  }
}
function register() {
  jQuery('html').removeClass('no-js').addClass('js');
  if (window.ReadyScript) {
    window.ReadyScript.forEach(x=> {
      loadScript(x.s,x.c);
    });
  }
  if (window.afterLoad) {
    window.afterLoad.forEach(x=> {
      if (x.p!=undefined) {
        window[x.f].apply(x.p);      
      }
      else {
        window[x.f].apply();      
      }
    });    
  }
  
  if (window.afterLoadWithEvents) {
    $(window).on('scroll.afterLoad',_checkafterLoadEvents);
    window.afterLoadWithEvents.forEach(x=> {
      if (x.evt) {
        $(x.el).on(x.evt+'.'+x.f,_checkafterLoadEvents)
      }
    });
  }
}
  
// window.afterLoadWithEvents = window.afterLoadWithEvents || [];
//   window.afterLoadWithEvents.push(
//   {
//       f:"_register",
//       evt: 'mousemove',
//       el: document
//   });
// function _register() {
//   checkUserLocation();
// };
$(document).ready(function(){
  register(); 
  if ($('[data-cart-qty]').length>0) {
    $('[data-cart-qty]').on('focusout',function() {
      if (parseInt($(this).data('cart-qty'))!=parseInt($(this).val())) {
        $(this).closest('form').get(0).submit();
      }
    });
  }
});

// load scripts after page load
function loadScript(sc,callback) {
  if ($.isArray(sc)) {    
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc[0];
    sc.splice(0,1);   
    if (sc.length>0) {
      $(lc).on('load',function() {loadScript(sc,callback)});           ;
    }
    else if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  }
  else {
    let lc = document.createElement('script'); lc.type = 'text/javascript'; 
    lc.src = sc;
    if (callback!=undefined) {
      $(lc).on('load',function() {window[callback].apply()});   
    }
    document.getElementsByTagName('body')[0].appendChild(lc);
  }
}

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});
  
var _productsData=[];
var _productsForTags=[];
var _swatchSettings={
  template:'<div class="swatches product-card__swatches">{{items}}</div>',
  item:`<a class="swatches__col" data-product-id="{{id}}" href="/products/{{url}}" aria-label="{{name}}">
<div class="swatches__swatch {{current}}">
  <span style="background-color: {{color}}"></span>
</div>
<div class="swatches__tag tool-tip tool-tip--swatch"><div class="tool-tip__label">{{name}}</div></div>
</a>`,   
  itemImage:`<a class="swatches__col" data-product-id="{{id}}" href="/products/{{url}}" aria-label="{{name}}">
<div class="swatches__swatch {{current}}">
  <span class='lazyload' data-bg="{{image}}"></span>
</div>
<div class="swatches__tag tool-tip tool-tip--swatch"><div class="tool-tip__label">{{name}}</div></div>
</a>`, 
  overlay:'<div class="product-card__overlays"><div class="product-card__overlay product-card__overlay--{{overlay}}">{{message}}</div></div>'
};
function renderSwatchAndOverlay(tags,callback) {
  if (tags.length>0) {      
  var tagsVar="tag:'"+tags.join("' OR '")+"'";
    FetchDataWithVariables(`query($tagsVar: String){
      products( first: 250,query:$tagsVar) {
        edges{
          node {
            id
            handle
            title
            tags
            images(first:2) {    
              edges {       
                node {
                  originalSrc     
                  id
                }
              }
            }
            metafields (identifiers: [ 
             {namespace: "accentuate", key: "swatchname"},
             {namespace: "accentuate", key: "swatchimage"}
            ]){           
              value
              key
              namespace
            }
            variants(first: 100) {
            edges {
              node {       
                price { amount }
                compareAtPrice { amount }
                availableForSale
                id                    
              }
            }
          }
        }
      }  
    }       
  }`,{tagsVar},function(data) {
    let Products = data.data.products.edges;
    for(let p of Products) {
      if (_productsData.filter(c=>c.id==p.node.id).length==0) {
        let _product={
          id:p.node.id.replace('gid://shopify/Product/',''),
          handle:p.node.handle,
          title:p.node.title
        };
        _product.overlays=[]; 

        for(let mf of p.node.metafields) {                   
          if (mf!=null && mf.key=='swatchimage') _product.swatchImage=mf.value;
          if (mf!=null && mf.key.indexOf('_overlay')!=-1) 
          _product.overlays.push({key:mf.key,value:mf.value});
          if (mf!=null && mf.key=='overlay') _product.overlays.push({key:mf.key,value:mf.value});
        }       
        p.node.tags.forEach(t=>{
          if (t.startsWith("Product Group Code|")) _product.GroupCode=t.replace('Product Group Code|','');
          if (t.startsWith("Swatch Name|")) _product.swatchName=t.replace('Swatch Name|','');
          if (t.startsWith("Swatch Colour|")) _product.swatchColor=t.replace('Swatch Colour|','');          
          if (t.startsWith("Swatch Image|")) _product.swatchImage=t.replace('Swatch Image|','');                          
        });            
        _product.images_info=[];
        for(let v of p.node.images.edges) {   
          _product.images_info.push({
            id:v.node.id,
            src:v.node.originalSrc,
            width:1000,
            height:1500
          });               
        }
        _product.variants=[];    
        let allowSale=false;
        for(let v of p.node.variants.edges) {   
          if (v.node.availableForSale===true) allowSale=true;
          _product.variants.push({
            id:v.node.id,
            price:parseFloat(v.node.price.amount)*Shopify.currency.rate,
            available:v.node.availableForSale,
            compare_at_price:v.node.compareAtPrice!=null?parseFloat(v.node.compareAtPrice.amount)*Shopify.currency.rate:null
          });               
        }
        let minPriceVariant=_product.variants.sort((a, b) => a.price - b.price)[0];
        _product.compare_at_price_min=parseFloat(minPriceVariant.compare_at_price);
        _product.price_min=parseFloat(minPriceVariant.price);
        let _overlayHtml=_swatchSettings.overlay;
        let overlayItems=[];
        _product.overlays.forEach(o=> {
          switch (o.key) {
            case 'top_left_overlay':  
              _overlayHtml=_overlayHtml.replace('{{overlay}}','top-left');
              break;
            case 'top_right_overlay':
              _overlayHtml=_overlayHtml.replace('{{overlay}}','top-right');
              break;
            case 'bottom_overlay':
              _overlayHtml=_overlayHtml.replace('{{overlay}}','bottom');
              break;
            default:
              _overlayHtml=_overlayHtml.replace('{{overlay}}','');
              break;
            }
            overlayItems.push(_overlayHtml.replace('{{message}}',o.value));
          });
          _product.overlay=overlayItems.join('');
          if (allowSale) {
            _productsData.push(_product);
          }
        }
      }   
      callback.apply();
    });
  }
  else {
    callback.apply();
  }
} 

document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = "url('" + bg + "')";
  }
});

let lgInstance;
document.addEventListener('DOMContentLoaded', () => {
  // Product Page LightGallery Popup
  if($("#lightgallery").length != 0) {
    const lgElement = document.getElementById('lightgallery');
    lgInstance = lightGallery(document.getElementById('lightgallery'), {
      selector: '.product-images__featured-item:not(.pdf-slide):not(.model-slide)',
      plugins: [lgZoom, lgThumbnail, lgVideo],
      speed: 100,
      thumbnail: true,
      getCaptionFromTitleOrAlt: false,
      download: false,
      videojs: true,
      licenseKey: 'C1DB9144-799D4957-B3C1226F-C451F4A3',
      mobileSettings: { 
        controls: true, 
        showCloseIcon: true,
        download: false, 
      }
    });

    // Round the width of the product images to prevent next slide visibility due to rounded width slides.
    function floorWidth() {
      if (window.innerWidth <= 768) {
        document.querySelectorAll('.product-images__featured').forEach(prodImages => {
          prodImages.style.width = '';
        });
        return;
      }
      document.querySelectorAll('.product-images__featured').forEach(prodImages => {
        const prodImagesContainer = prodImages.parentElement;
        const width = Math.floor(prodImagesContainer.getBoundingClientRect().width);
        prodImages.style.width = `${width}px`;
      });
    }
    floorWidth();
    window.addEventListener('resize', floorWidth);

    let thumbnailsLoaded = false;
    lgElement.addEventListener('lgAfterSlide', (event) => {
      const { index, prevIndex } = event.detail;
      console.log('Slide changed from ' + prevIndex + ' to ' + index);

      if (!thumbnailsLoaded) {
        const thumbs = document.querySelectorAll('.lg-thumb-item img');
        thumbs.forEach((thumb, i) => {
          const lgIndex = thumb.dataset.lgItemId;
          const mainImg = document.getElementById('image' + (i + 1));
          if (thumb && mainImg && mainImg.dataset.src) {
            thumb.src = mainImg.dataset.src;
          }
          if (thumb && (thumb.src === '' || thumb.src.includes('/products/'))) {
            const slideEl = document.querySelector(`.swiper-slide[data-swiper-slide-index="${lgIndex}"]`);
            if (slideEl) {
              const vimeoVideo = slideEl.querySelector('.responsive-video--vimeo');
              if (vimeoVideo && vimeoVideo.dataset.previewImage) {
                thumb.src = vimeoVideo.dataset.previewImage;
              }
            }
          }
        });
        thumbnailsLoaded = true;
      }

      setTimeout(() => {
        const lgIndex = event.detail.index;
        const currentSlide = document.querySelector('.lg-item.lg-current.lg-loaded');
        if (!currentSlide) return;

        // Zoom buttons logic
        const img = currentSlide.querySelector('img');
        const zoomIn = document.querySelector('.lg-zoom-in');
        const zoomOut = document.querySelector('.lg-zoom-out');
        const isZoomable = img ? img.naturalWidth > img.offsetWidth : false;

        if (zoomIn) {
          const isVideo = !!currentSlide.querySelector('.lg-video-cont');

          if (isVideo) {
            zoomIn.style.display = 'none';
            zoomIn.classList.add('lg-disabled');
          } else if (!isZoomable) {
            zoomIn.style.display = 'none';
            zoomIn.classList.add('lg-disabled');
          } else {
            zoomIn.style.display = 'block';
            zoomIn.classList.remove('lg-disabled');
          }
        }

        console.log('Active slide index:', lgIndex, 'Zoomable?', isZoomable, 'Image:', img);

        // // Find corresponding Swiper slide
        // const allSwiperSlides = document.querySelectorAll('.swiper-slide.product-images__featured-item');
        // const swiperSlide = allSwiperSlides[lgIndex];
        // if (!swiperSlide?.classList) return;

        // // Only handle model slides
        // if (!swiperSlide.classList.contains('product-images__model')) return;

        // currentSlide.classList.add('lg-model');

        // // Only clone the model if it hasn't been added yet
        // const existing = currentSlide.querySelector('.lg-cloned-model');
        // if (!existing) {
        //   const model = swiperSlide.querySelector('.product-3d-model');
        //   if (model) {
        //     const clone = model.cloneNode(true);
        //     clone.classList.add('lg-cloned-model');
        //     // Remove the touch-action attribute so it behaves normally in the modal
        //     clone.querySelector('model-viewer')?.removeAttribute('touch-action');
        //     currentSlide.appendChild(clone);
        //   }
        // }

        // // Force LightGallery into zoom/“actual size” mode for model slide
        // setTimeout(() => {
        //   const zoomButton = document.querySelector('.lg-zoom-in');
        //   zoomButton.click();
        // }, 50);

      }, 250);
    });
  }
  // All LightGallery slides
  const allSlides = Array.from(document.querySelectorAll('.product-images__featured-item'));
  // Find the index of the first slide inside a video Swiper slide
  const videoSlideIndex = allSlides.findIndex(el => el.closest('.product-images__video'));
  // Button to open the video slide
  const videoButton = document.querySelector('.open-video-slide');
  if (videoButton && videoSlideIndex >= 0) {
    videoButton.addEventListener('click', e => {
      e.preventDefault();
      lgInstance.openGallery(videoSlideIndex);
    });
  }
  if (window.location.hash === '#video' && videoButton && videoSlideIndex >= 0) {
    videoButton.click();
  }
});

// Swiper Video play and pause
var vids = $(".product-images__video video"); 
$.each(vids, function(){
  this.controls = false; 
}); 
$(".product-images__video video").click(function() {
  if (this.paused) {
    this.play();
  } else {
    this.pause();
  }
});
$(".product-images__video video").bind('stop pause', function(e) {
  console.log("stopped");
  $(this).parent().removeClass('responsive-video--stopped');
});

$(".product-images__video video").bind('play', function(e) {
  console.log("playing");
  $(this).parent().addClass('responsive-video--stopped');
});

var productImagesSwiper;

// Swiper Slider - Default
if ($('.swiper--default').length > 0) {
  initSwipers();
}

// Resize swiper slides to 100% width
/*
function fixSlideWidths(swiper) {
  swiper.slides.forEach(slide => {
    slide.style.width = '100%';
  });
}
*/

function trackHeroCardVisibility(swiper) {
  let animationFrame = null;

  function refreshVisibility() {
    if (swiper.destroyed) return;
    const viewport = swiper.el.getBoundingClientRect();
    const visibility = swiper.slides.map((slide) => {
      const bounds = slide.getBoundingClientRect();
      return {
        slide,
        offscreen: bounds.right <= viewport.left + 0.5 || bounds.left >= viewport.right - 0.5,
      };
    });
    visibility.forEach(({ slide, offscreen }) => {
      slide.classList.toggle('hero-grid__sub-slide--offscreen', offscreen);
    });
  }

  function stopTracking() {
    if (animationFrame !== null) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  }

  function trackFrame() {
    animationFrame = null;
    if (swiper.destroyed) return;
    refreshVisibility();
    if (swiper.animating) {
      animationFrame = requestAnimationFrame(trackFrame);
    }
  }

  function startTracking() {
    stopTracking();
    refreshVisibility();
    animationFrame = requestAnimationFrame(trackFrame);
  }

  function finishTracking() {
    stopTracking();
    refreshVisibility();
  }

  swiper.on('setTranslate resize update', refreshVisibility);
  swiper.on('transitionStart', startTracking);
  swiper.on('transitionEnd', finishTracking);
  swiper.on('beforeDestroy', stopTracking);
  refreshVisibility();
}

function initSwipers() {
  let swiperInstances = [];
  $(".swiper--default").each(function(index, obj){
    const $this = $(this);
    if (!$this.hasClass('swiper-initialized')) {
      $this.css('display', 'block');
      $this.addClass("swiper-" + index); 
      $this.find(".swiper-pagination").addClass("pagination-" + index);
      $this.siblings(".swiper-button-prev").addClass("prev-" + index);
      $this.siblings(".swiper-button-next").addClass("next-" + index);
      $this.find(".swiper-button-prev").addClass("prev-" + index);
      $this.find(".swiper-button-next").addClass("next-" + index); 
      $this.find(".swiper-scrollbar").addClass("scrollbar-" + index);

      if($this.hasClass('swiper--play-pause')) {
        $this.on('click', function(e){
          if ($(e.target).closest('.hero-grid__slide-button').length) {
            return;
          }
          if ($(e.target).closest('.swiper-pagination-bullet').length) {
            // Swiper has already selected the clicked slide; resume without advancing it.
            swiperInstances[index].autoplay.start();
            $this.find('.swiper-button--play').hide();
            $this.find('.swiper-button--pause').show();
            $this.removeClass('swiper-paused');
            return;
          }
          if($this.hasClass('swiper-paused')) {
            swiperInstances[index].slideNext();
            swiperInstances[index].autoplay.start();
            $this.find('.swiper-button--play').hide();
            $this.find('.swiper-button--pause').show();
            $this.removeClass('swiper-paused');

          } else {
            swiperInstances[index].autoplay.stop();
            $this.find('.swiper-button--pause').hide();
            $this.find('.swiper-button--play').show();
            $this.addClass('swiper-paused');
          }
        });
        $this.find('.hero-grid__video-full-screen').on('click', function(e){
          e.stopPropagation(); // Prevent click from bubbling up to the carousel
          swiperInstances[index].autoplay.stop();
          $this.find('.swiper-button--pause').hide();
          $this.find('.swiper-button--play').show();
          $this.addClass('swiper-paused');
        });
      }

      if($this.hasClass('swiper--last-slide')) {
        $initial = $this.find('.swiper-slide').length;
      } else {
        $initial = 0;
      }

      if($this.hasClass('swiper--loop')) {
        $loop = true;
      } else {
        $loop = false;
      }
      
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        $autoplay = false; // disable autoplay if reduced motion is preferred
      } else if($this.hasClass('swiper--autoplay')) {
        if($this.hasClass('swiper--pause')) {
          $autoplay = { delay: 4000, disableOnInteraction: true, pauseOnMouseEnter: true };
        } else {
          $autoplay = { delay: 4000, disableOnInteraction: false };
        }
      } else {
        $autoplay = false;
      }

      if($this.hasClass('swiper--snap')) {
        $freemode = false;
      } else {
        $freemode = true;
      }

      if($this.hasClass('swiper--centre')) {
        $centre = true;
      } else {
        $centre = false;
      }

      if($this.find(".swiper-pagination").length) {
        $pagination = '.pagination-' + index;
      } else {
        $pagination = null;
      }
      
      if($this.find(".swiper-pagination--progress").length) {
        $clickable = true;
        $render_bullet = function (index, className) {return '<span class="' + className + '">' + '<em>'+'</em>' + '<i></i>' + '<b></b>'  + '</span>';};
      } else {
        $clickable = true;
        $render_bullet = null;
      }

      if($this.find(".swiper-pagination--fraction").length) {
        $pagination_type = 'fraction';
      } else {
        $pagination_type = 'bullets';
      }

      if($this.find(".swiper-button-next").length) {
        $next = '.next-' + index;
      } else if($this.siblings(".swiper-button-next").length) {
        $next = '.next-' + index;
      } else {
        $next = null;
      }

      if($this.find(".swiper-button-prev").length) {
        $prev = '.prev-' + index;
      } else if($this.siblings(".swiper-button-prev").length) {
        $prev = '.prev-' + index;
      } else {
        $prev = null;
      }    

      if($this.find(".swiper-scrollbar").length) {
        $scrollbar = '.scrollbar-' + index;
      } else {
        $scrollbar = null;
      }
      
      if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        $speed = 0; 
      } else {
        $speed = 300;
      }
      const isHeroCardCarousel = $this.is('.hero-grid-carousel .hero-grid__sub-swiper');
      swiperInstances[index] = new Swiper(".swiper-" + index, {
        on: isHeroCardCarousel ? { init: trackHeroCardVisibility } : {},
        speed: $speed,
        autoplay: $autoplay,
        initialSlide: $initial,
        loop: $loop,
        keyboard: {
          enabled: false, // initially false, enable on focus
          onlyInViewport: true,
        },
        slidesPerView: 'auto',
        centerInsufficientSlides: $centre,
        navigation: {
          prevEl: $prev,  
          nextEl: $next, 
        },
        pagination: {
          el: $pagination,
          type: $pagination_type,
          clickable: $clickable,
          renderBullet: $render_bullet,
        },
        scrollbar: {
          el: $scrollbar,
          draggable: true,
          snapOnRelease: false,
        },
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: {
          enabled: $freemode,
          sticky: true,
          minimumVelocity: 0,
          momentumBounce: false,
          momentumRatio: 0.5,
          momentumVelocityRatio: 1.5,
        }
      });
    }

    const swiperEl = $this[0];
    swiperEl.setAttribute('tabindex', '0'); // Make focusable
    swiperEl.addEventListener('focusin', () => {
      swiperInstances[index].keyboard.enable();
    });
    swiperEl.addEventListener('focusout', () => {
      swiperInstances[index].keyboard.disable();
    });

  });

  setTimeout(function () {
    for (const slider of swiperInstances) {
      if (slider!=undefined) {
        slider.update();
        if(slider.isLocked == true) {
          var current = $(slider.el).children(".swiper-nav");
          $(slider.el).addClass('swiper--locked');
          $(slider.el).siblings('.section__footer').addClass( "section__footer--locked");
          $(current).addClass('swiper-nav--locked');
        }
        slider.on('lock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(slider.el).addClass('swiper--locked');
          $(slider.el).siblings('.section__footer').addClass( "section__footer--locked");
          $(current).addClass('swiper-nav--locked');
        });
        slider.on('unlock', function () {
          var current = $(slider.el).children(".swiper-nav");
          $(slider.el).removeClass('swiper--locked');
          $(slider.el).siblings('.section__footer').removeClass( "section__footer--locked");
          $(current).removeClass('swiper-nav--locked');
        });
        var id = $(slider.el).attr('id');
      }
    }
  }, 50);
}

$('.swiper-button-prev, .swiper-button-next').on('keydown', function (e) {
  if (e.key === 'Enter' || e.key === ' ') {
    e.preventDefault(); // Prevent default scroll behavior for Space
    $(this).click(); // Trigger click event
  }
});

// Swiper Slider - Product Page
if ($('.swiper--product-images').length > 0) {
  const productThumbsSwiper = new Swiper(".swiper--product-thumbs", {
    keyboard: { enabled: true },
    slidesPerView: 'auto',
    watchSlidesProgress: true,
    mousewheel: { forceToAxis: true },
    navigation: {
      nextEl: ".product-images__thumb-next",
      prevEl: ".product-images__thumb-prev",
    },
  });

  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $speed = 0; 
  } else {
    $speed = 300;
  }

  productImagesSwiper = new Swiper(".swiper--product-images", {
    speed: $speed,
    loop: true,
    slidesPerView: 1,
    keyboard: { enabled: true },
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    pagination: {
      el: ".product-images__pagination",
      clickable: true,
      type: 'fraction',
    },
    navigation: {
      nextEl: ".product-images__nav-next",
      prevEl: ".product-images__nav-prev",
    },
    thumbs: {
      swiper: productThumbsSwiper,
      // Custom behavior handled below
    },
    on: {
      slideChange: function () {
        const activeSlide = this.slides[this.activeIndex];

        // Lazy-load normal images
        const img = activeSlide.querySelector("img[data-src]");
        if (img && img.dataset.src && img.dataset.lazyLoaded !== "true") {
          img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.dataset.lazyLoaded = "true"; // mark as loaded
        }

        // Lazy-load YouTube background
        const videoDiv = activeSlide.querySelector('.responsive-video--youtube');
        if (videoDiv && (!videoDiv.style.backgroundImage || videoDiv.style.backgroundImage === '')) {
          const videoId = videoDiv.dataset.videoId.replace(/^\//, '');
          const thumbnailUrl = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
          videoDiv.style.backgroundImage = `url("${thumbnailUrl}")`;
        }

        // Lazy-load Vimeo background using Shopify media preview
        const vimeoDiv = activeSlide.querySelector('.responsive-video--vimeo');
        if (vimeoDiv && (!vimeoDiv.style.backgroundImage || vimeoDiv.style.backgroundImage === '')) {
          const preview = vimeoDiv.dataset.previewImage;
          if (preview) vimeoDiv.style.backgroundImage = `url("${preview}")`;
        }
      },
    },
    /*
    on: {
      resize: function(swiper) {
        fixSlideWidths(swiper);
      },
      observerUpdate: function(swiper) {
        fixSlideWidths(swiper);
      }
    }
    */
  });

  // Enable keyboard selection on thumbnails
  document.querySelectorAll('.swiper--product-thumbs .swiper-slide').forEach((thumb, index, previousIndex) => {
    thumb.setAttribute("tabindex", "0"); // Make slides focusable
    
    thumb.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { // Enter or Space key
        e.preventDefault();
        productImagesSwiper.slideToLoop(index);
      }
    });

    // Override click behavior for PDF thumbs
    /*
    if (thumb.classList.contains('product-images__pdf-slide')) {
      thumb.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        // Instead of syncing to a nonexistent slide, sync to the one before
        const targetIndex = 0;
        if (targetIndex >= 0) {
          productImagesSwiper.slideToLoop(targetIndex);
          productThumbsSwiper.slideToLoop(targetIndex);
        }
      });
    }
    */
  });
}

function _getWindowLocation() {
  for (var t = window.location.href.replace(/%3C/g, "&lt;").replace(/%3E/g, "&gt;"), e = [], n = 0; n < t.length; n++) e.push(t.charAt(n));
  var i = e.join("").split("&lt;").join("%3C").split("&gt;").join("%3E"),
      r = "",
      o = i.replace(/#.*$/, "");
  return o.split("?").length > 1 && (r = o.split("?")[1]).length > 0 && (r = "?" + r), { pathname: window.location.pathname, href: i, search: r };
}

// Show Loading Overlay
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}

/*********************
MANAGE AT HOME
*********************/
// currencySymbol = "£";
$(document).ready(function(){  
  // Popup - Open
  /*
  $('[data-popup]').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      var popup = $(this).attr("data-popup");
      $('#popup-' + popup).addClass('popup--active');
      $('html').addClass('noscroll-popup');
    }
  });
  */
  // Popup - Accessible
  let lastFocusedElement; // store the element that opened the popup
  $('[data-popup]').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();

      lastFocusedElement = this; // store the trigger

      var popup = $(this).attr("data-popup");
      var $popup = $('#popup-' + popup);

      $popup.addClass('popup--active');
      $('html').addClass('noscroll-popup');

      // Focus first focusable element inside popup
      var $focusable = $popup.find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').first();
      if ($focusable.length) {
        $focusable.focus();
      } else {
        $popup.attr('tabindex', '-1').focus();
      }
    }
  });

  // Popup - Close
  /*
  $('.popup__close, [data-close]').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      $('.popup').removeClass('popup--active');
      $('html').removeClass('noscroll-popup');
    }
  });

  // Popup - Close Outside Panel
  $('.popup__panel').click(function(event) {
    event.stopPropagation(); // Prevent the click event from reaching .popup
  });
  $('.popup').click(function() {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('noscroll-popup');
  });
  */
  // Popup - Close via close button or data-close
  $('.popup__close, [data-close]').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();

      $('.popup').removeClass('popup--active');
      $('html').removeClass('noscroll-popup');

      // Restore focus to the element that opened the popup
      if (lastFocusedElement) {
        $(lastFocusedElement).focus();
      }
    }
  });
  // Popup - Close by clicking outside panel
  $('.popup__panel').click(function(event) {
    event.stopPropagation(); // prevent click bubbling
  });
  $('.popup').click(function() {
    $('.popup').removeClass('popup--active');
    $('html').removeClass('noscroll-popup');

    // Restore focus to the element that opened the popup
    if (lastFocusedElement) {
      $(lastFocusedElement).focus();
    }
  });
  // Open brochure via URL
  if (window.location.hash === '#brochure') {
    const brochureButton = document.querySelector(
      '.product-media__button[data-popup="pdf"][pdf-viewer]'
    );
    if (brochureButton) {
      brochureButton.click();
    }
  }
  // Open 3D model via URL
  if (window.location.hash === '#model') {
    const modelButton = document.querySelector(
      '.product-media__button[data-popup="model-viewer"][model-viewer]'
    );
    if (modelButton) {
      modelButton.click();
    }
  }
  // Play Video 
  var vids = $(".play-video"); 
  $.each(vids, function(){
    this.controls = true; 
  }); 
  // $(".play-video").click(function() {
  //   if (this.paused) {
  //     this.play();
  //   } else {
  //     this.pause();
  //   }
  // });
  $(".play-video").bind('stop pause', function(e) {
    console.log("stopped");
    $(this).parent().removeClass('responsive-video--stopped');
  });

  $(".play-video").bind('play', function(e) {
    console.log("playing");
    $(this).parent().addClass('responsive-video--stopped');
  });
  
  // Text Section Read More
  $('.text__reveal').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      $(this).hide();
      $(this).next().slideToggle(200);
    }
  });

  // Two Column Read More
  /*
  $('.two-column__more').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      $(this).hide();
      $(this).next().slideToggle(200);
    }
  });
  */

  $('.two-column__more').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      $this.attr('aria-expanded', !isExpanded);
      $this.next('.two-column__hidden').addClass('two-column--expanded');
      $this.hide();
    }
  });

  // Header Info Nav
  $('.header-info__title').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      // Toggle icon and slide content
      $this.find('.header-info__title-icon').toggle();
      $this.next().slideToggle("fast");
    }
  });

  // Featured Collection - Tabs
  $('.featured-collection__tab').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      var header_html = $this.html();
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      var tab = $(this).data('tab');
      var header = $(this).data('header');
      $('.featured-collection__tab').removeClass('featured-collection__tab--active');
      $('.featured-collection__tab-content').hide();
      $(this).addClass('featured-collection__tab--active');
      $('#' + tab).show();
      $('.featured-collection__header-wrap').html(header_html);
    }
  });

  // Filter View Option
  $('.filter-view__option').off('click').on('click keydown', function (e) {
    if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
      $('.filter-view__option').removeClass('filter-view__option--active');
      $(this).addClass('filter-view__option--active');
      
      if ($(this).hasClass('filter-view__option--list')) {
        $('.collection__products').addClass('collection__products--list');
        $('.collection__products').removeClass('collection__products--grid');
      } else {
        $('.collection__products').removeClass('collection__products--list');
        $('.collection__products').addClass('collection__products--grid');
      }
    }
  });

function openAccordion(hash, smoothScroll = true) {
  if (!hash) return;

  var targetElement = $(hash);
  if (!targetElement.length) return;

  // Case 1: The hash itself is the accordion container
  var accordion = targetElement.hasClass('product-details__accordion')
    ? targetElement
    : targetElement.closest('.product-details__accordion');

  if (!accordion.length) {
    // Not inside or equal to an accordion — just scroll
    if (smoothScroll) {
      $("html, body").animate({ scrollTop: targetElement.offset().top - 24 }, 400);
    }
    return;
  }

  // Close all accordions
  $('.product-details__accordion-panel').hide().attr('aria-hidden', 'true');
  $('.product-details__accordion-title').removeClass('active').attr('aria-expanded', 'false');
  $('.product-details__accordion-chevron--down').show();
  $('.product-details__accordion-chevron--up').hide();

  // Open the target accordion
  var titleElement = accordion.find('.product-details__accordion-title');
  var panelElement = accordion.find('.product-details__accordion-panel');

  titleElement.addClass('active').attr('aria-expanded', 'true');
  panelElement.attr('aria-hidden', 'false').show();
  titleElement.find('.product-details__accordion-chevron--down').hide();
  titleElement.find('.product-details__accordion-chevron--up').show();

  // Scroll behavior
  if (smoothScroll) {
    $("html, body").animate({ scrollTop: targetElement.offset().top - 24 }, 400);
  }
}


  // Check for hash on page load (no smooth scroll)
  if (window.location.hash) {
    setTimeout(() => {
      openAccordion(window.location.hash, false);
    }, 300);
  }

  // Smooth scroll links
  $(".collection__description a[href^='#'], .scroll-link").click(function (e) {
    e.preventDefault();
    var hash = $(this).attr("href");
    if (hash !== '#product_options') openAccordion(hash, true);

    // Update the URL hash without scrolling
    if (history.pushState) {
      history.pushState(null, null, hash);
    } else {
      location.hash = hash;
    }

    // Scroll directly to offset
    var target = $(hash);
    if (target.length) {
      var offset = target.offset().top;
      if (hash === '#product_options') {
        var optionsColumn = target.closest('.product-main__sub-col--options')[0];
        if (optionsColumn && getComputedStyle(optionsColumn).position === 'sticky') {
          var originalPosition = optionsColumn.style.getPropertyValue('position');
          var originalPriority = optionsColumn.style.getPropertyPriority('position');
          optionsColumn.style.setProperty('position', 'static', 'important');
          try {
            offset = target.offset().top;
          } finally {
            if (originalPosition) {
              optionsColumn.style.setProperty('position', originalPosition, originalPriority);
            } else {
              optionsColumn.style.removeProperty('position');
            }
          }
        }
        offset -= 110;
      } else if ($(this).is(".back-up__button.scroll-link")) {
        offset -= 140;
      }
      $("html, body").stop().animate({ scrollTop: offset }, 400);
    }
  });

  $(".scroll-to-search").click(function(event) {
    event.preventDefault(); // Prevent default link behavior
    $("html, body").animate({ scrollTop: 0 }, 400, function() {
      $(".header-search__input").val("").focus(); // Clear input and focus
    });
  });

  // Sort by dropdown
  $('.filter-sort').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      event.preventDefault();
      var $this = $(this);
      if ($this.find('.filter-sort__title').hasClass('filter-sort__title--active')) {
        $this.find('.filter-sort__title').attr('aria-expanded','false');
        $this.find('.filter-sort__title').removeClass('filter-sort__title--active');
        $this.find('.filter-sort__list').removeClass('filter-sort__list--active');
        $this.find('.filter-sort__list').slideUp(200);
      } else {
        $this.find('.filter-sort__title').addClass('filter-sort__title--active');
        $this.find('.filter-sort__title').attr('aria-expanded','true');
        $this.find('.filter-sort__list').addClass('filter-sort__list--active');
        $this.find('.filter-sort__list').slideDown(200);
      }
    }
  });

  $('.discontinued__banner-button').off('click').on('click', function (event) {
    $('body').removeClass('discontinued-product');
    $('#maincontent').css('height', 'auto');
  });

  // Product Details Accordion
  $('.product-details__accordion-title').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';

      // Toggle aria-expanded attribute on title
      $this.attr('aria-expanded', !isExpanded);

      // Get the element next to the title
      let $content = $this.next();

      // Toggle aria-hidden on the content element
      $content.attr('aria-hidden', isExpanded); // true if expanded, false if collapsed

      $content.slideToggle(200);
      $this.toggleClass('active');
      $this.children('.product-details__accordion-chevron').toggle();
    }
  });

  // General Accordion (NEW)
  $('.faqs-accordion__title').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      if($(this).hasClass('active')) {
        $('.faqs-accordion__title').next().slideUp(200);
        $('.faqs-accordion__title').next().attr('aria-hidden','true');
        $('.faqs-accordion__title').removeClass('active');
        $('.faqs-accordion__title').attr('aria-expanded','false');
        $(this).find('.faqs-accordion__chevron--down').show();
        $(this).find('.faqs-accordion__chevron--up').hide();
      } else {
        $('.faqs-accordion__title').removeClass('active');
        $('.faqs-accordion__title').attr('aria-expanded','false');
        $('.faqs-accordion__title').next().slideUp(200);
        $('.faqs-accordion__title').next().attr('aria-hidden','true');
        $('.faqs-accordion__title').find('.faqs-accordion__chevron--up').hide();
        $('.faqs-accordion__title').find('.faqs-accordion__chevron--down').show();
        $(this).next().slideDown(200);
        $(this).next().attr('aria-hidden','false');
        $(this).addClass('active');
        $(this).attr('aria-expanded','true');
        $(this).find('.faqs-accordion__chevron--down').hide();
        $(this).find('.faqs-accordion__chevron--up').show();
      }
    }
  });

  // Cart Summary Accordion
  $('.cart-summary__accordion-header').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      $(this).next().slideToggle(200);
      $(this).find('svg').toggle();
    }
  });

  // Article Skip
  $('.article__skip-header').off('click').on('click', function (event) {
    $(this).next().slideToggle(200);
    $(this).toggleClass('article__skip-header--active');
    $(this).children('.article__skip-icon').toggle();
  });
  $('.article__skip-link').off('click').on('click', function (e) {
    e.preventDefault();
    var targetElement = $(this).attr("href");
    var targetPosition = $(targetElement).offset().top;
    $("html, body").animate({ scrollTop: targetPosition - 0 }, 400);
    $('.article__skip-dropdown').slideUp(200);
    $('.article__skip-header').removeClass('article__skip-header--active');
    $('.article__skip-icon').toggle();
  });

  // Article Sources
  $('.article-sources__header').off('click').on('click', function (event) {
    $(this).next().slideToggle(200);
    $(this).children('.article-sources__header-icon').toggle();
  });

  // Variant Delivery
  $('.variant__delivery-radio').on('click',function(e) {
    $(this).parent().find('.variant__delivery-full').addClass('variant__delivery-full--active');
    $(this).parent().find('.variant__delivery-bottom').addClass('variant__delivery-bottom--active');
    $(this).parent().find('.variant__delivery-more').hide();
    updateConfiguredPrice();
  });

  // Collection Navigational Accordion
  $('.collection-navigational__shop-title').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      let $this = $(this);
      let isExpanded = $this.attr('aria-expanded') === 'true';
      // Toggle aria-expanded attribute
      $this.attr('aria-expanded', !isExpanded);
      // Toggle icon and slide content
      $this.find('.collection-navigational__shop-icon').toggle();
      $this.next().slideToggle(200);
    }
  });

  // Copy to Clipboard - Fixed Version
  function CopyToClipboard(element, location, original, value, showNotification, notificationText) {
    // Check if there's already a notification in progress
    if (element.data('copying')) {
      return; // Exit early if already copying
    }
    
    // Mark element as currently copying
    element.data('copying', true);

    // Store the currently focused element
    var activeElement = document.activeElement;
    
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();

    // Restore focus
    if (activeElement) activeElement.focus();
    
    if (typeof showNotification === 'undefined') {
      showNotification = true;
    }
    if (typeof notificationText === 'undefined') {
      notificationText = "Copied to clipboard";
    }
    
    if (showNotification) {
      // Store the original span text if not already stored
      if (!element.data('originalText')) {
        element.data('originalText', original);
      }
      
      // Find and update the existing span instead of creating new ones
      var spanElement = element.find('span').first();
      var originalText = element.data('originalText');
      
      // Change the text to notification
      spanElement.text(notificationText);
      
      // Fade in effect (optional, since text is already visible)
      spanElement.fadeIn("slow", function () {
        setTimeout(function () {
          // Restore original text
          spanElement.text(originalText);
          // Remove the copying flag
          element.removeData('copying');
        }, 1600);
      });
    }
  }

  // Copy Discount to Clipboard
  $(".copy-to-clipboard").click(function (event) {
    var element = $(this);
    var dvalue = $(this).find('span').text();
    var original = $(this).find('span').text();
    var location = "before";
    event.preventDefault();
    CopyToClipboard(element, location, original, dvalue, true, "Copied");
  });

  // Copy to Clipboard RSS
  $(".copy-to-clipboard-rss").click(function (event) {
    var element = $(this);
    var dvalue = $(this).attr('data-rss');
    var original = $(this).find('span').text();
    var location = "after";
    event.preventDefault();
    CopyToClipboard(element, location, original, dvalue, true, "Copied");
  });

  // Cart VAT Application Checkbox
  $('#vat_application').on('change', function() {
    if ($('#vat_application:checked').length > 0) {
      $('.cart-vat__panel--form').slideDown(200);
      $('.cart-vat__footer').addClass('cart-vat__footer--active');
      $('.cart-vat__hover-wrap').addClass('cart-vat__hover-wrap--active');
    } else {
      $('.cart-vat__panel--form').slideUp(200);
      $('.cart-vat__footer').removeClass('cart-vat__footer--active');
      $('.cart-vat__hover-wrap').removeClass('cart-vat__hover-wrap--active');
    }
  });

  // Cart VAT disability select
  var declare_cart = $('.disability-message p').text();
  $('.disability-selector').on('change', function() {
    var optionSelected = $(this).find("option:selected");
    var textSelected   = optionSelected.text();
    $('.disability-message strong').remove();
    if(textSelected == 'Other') {
      $('.disability-textarea').show();
      var other_cart = declare_cart.replace(" by reason of","");
      $('.disability-message p').text(other_cart);
      $('.disability-message strong').remove();
    } else {
      $('.disability-textarea').hide();
      $('.disability-message p').text(declare_cart);
      $('.disability-message p').append('<strong>' + textSelected + '</strong>');
    }
  });

  // Cart VAT Radio
  /*
  $('.cart-vat__form-radio').click(function() {
    if($('#somebody_else').is(':checked')) {
      $('.cart-vat__form-hidden').show();
    } else {
      $('.cart-vat__form-hidden').hide();
    }
  });
  */
  const alwaysShowVatFields = window.location.pathname.replace(/\/$/, '') === '/pages/vat-relief-form' && !new URLSearchParams(window.location.search).has('218763');
  if (alwaysShowVatFields) {
    $('.cart-vat__form-hidden').show();
  }
  $('.cart-vat__form-radio').click(function() {
    if (alwaysShowVatFields || $('#somebody_else').is(':checked')) {
      $('.cart-vat__form-hidden').show();
    } else {
      $('.cart-vat__form-hidden').hide();
    }
  });
 
  _initCompare();

  const minimizebtn = document.querySelector('.minimize');
  const comparepanel = document.querySelector('.compare-slide');
  const backBtn = document.querySelector('.back-to-top');
  // Compare Page - Clear All
  $('[data-compare-clear]').on('click', function() {
    $('.compare__main').remove();
    $('.compare').addClass('compare--empty');
    sessionStorage.setItem('comparelist','');

    // Reset minimized state when cleared
    comparepanel.classList.remove('minimized');
    backBtn.classList.remove('lifted');
    minimizebtn.setAttribute('aria-label', 'Minimise panel');
    localStorage.setItem('panelMinimized', 'false');
  });

  // Compare Panel - Minimize
  function updateMinimizedState() {
    if (window.innerWidth < 1366) {
      // Force panel open on smaller screens
      comparepanel.classList.remove('minimized');
      backBtn.classList.remove('lifted');
      minimizebtn.setAttribute('aria-label', 'Minimise panel');
    } else {
      // Restore state from localStorage
      if (localStorage.getItem('panelMinimized') === 'true') {
        comparepanel.classList.add('minimized');
        backBtn.classList.add('lifted');
        minimizebtn.setAttribute('aria-label', 'Lock position');
      }
    }
  }
  // Initial check on page load
  updateMinimizedState();
  // Toggle minimized state and save to localStorage
  minimizebtn.addEventListener('click', () => {
    comparepanel.classList.toggle('minimized');
    backBtn.classList.toggle(
      'lifted',
      comparepanel.classList.contains('minimized')
    );
    minimizebtn.setAttribute(
      'aria-label',
      comparepanel.classList.contains('minimized') ? 'Lock position' : 'Minimise panel'
    );
    localStorage.setItem('panelMinimized', comparepanel.classList.contains('minimized'));
  });
  // Update on window resize
  window.addEventListener('resize', updateMinimizedState);

  // Compare Slide - Clear All
  $('.compare-slide__clear').on('click', function() {
    $('.product-card__tool-tip span').text('0');
    $('.compare-slide__button span').text('0');
    $('.compare-checkbox__tool-tip span').text('0');
    $('.compare-checkbox').prop('checked', false);
    $('.compare-slide').removeClass('compare-slide--active');
    $('.copyright').removeClass('copyright--compare-active');
    $('.product-card__compare').show();
    sessionStorage.setItem('comparelist','');
    document.querySelectorAll('[data-compare-slide] [data-compare-id]').forEach(x=> x.remove());
  });

});

function _processCompareCheckbox(el) {   
  let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');
  var compare_count = compareItems.length;
  $('.compare-checkbox__tool-tip span').text(compare_count);
  $('.compare-slide__button span').text('(' + compare_count + ')');
  if (compare_count > 0) {
    $('.compare-slide').addClass('compare-slide--active');
    $('.copyright').addClass('copyright--compare-active');
  } else {
    $('.compare-slide').removeClass('compare-slide--active');
    $('.copyright').removeClass('copyright--compare-active');
  }   
  if (compare_count > 1) {
    $('.compare-slide__add-more').hide();
    $('.compare-slide__button').show();
  } else {
    $('.compare-slide__add-more').show();
    $('.compare-slide__button').hide();
  }   
  if (compare_count > 0 && compare_count < 4) {
    if (el) {
       var type = $(el).attr('data-type');
       $('.compare-checkbox').each(function() {
          if($(this).attr('data-type') != type) {
            $(this).parent().hide();
          } else {
            $(this).parent().show();
          }
        });
    }
  } else {
    if (compare_count == 0) {
      $('.product-card__compare').show();
    }
    if (compare_count == 4) {
      $(".compare-checkbox:checkbox:not(:checked)").parent().hide();
    }
  }
}
function addCompare(_handle) {
  $.ajax({
    method    : 'GET',
    url       : document.location.origin+"/products/"+_handle+"/?view=comparesmall",        
    success: function (data) {
      const _html=new DOMParser().parseFromString(data, 'text/html').body.childNodes[0];         
      const cid=_html.dataset.compareId;    
      const cEl=document.querySelector('[data-compare-id="'+cid+'"]')
      if (cEl==null) {
      document.querySelector('[data-compare-slide]').insertBefore(_html,document.querySelector('[data-compare-slide] .compare-slide__col--compare'));
      _html.querySelector("[data-action='compare-remove']").addEventListener('click',function() {
        let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');
        const id =$(this).closest('[data-compare-id]').data('compare-id');
        compareItems=compareItems.filter(item => item !== id);
        document.querySelector('[data-compare-id="'+id+'"]').remove();
        sessionStorage.setItem('comparelist',JSON.stringify(compareItems));
        const els=document.querySelectorAll('[data-product-id="'+id+'"].compare-checkbox');
        els.forEach(el => {
          if (el) {
            el.checked=false;          
          }
          _processCompareCheckbox(el);  
        })
        
      });
    }
    }
  });
}
function _initCompare() {
   // Compare Checkbox
  if (!window.location.href.includes("pages/compare") && !window.location.href.includes("cart")) {
    document.querySelectorAll('[data-compare-slide] [data-compare-id]').forEach(x=> x.remove());
    let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');
    compareItems.forEach(x=> {    
      const els=document.querySelectorAll('[data-product-id="'+x+'"].compare-checkbox');
      addCompare(x);
      if (els) {
        els.forEach(el => {
           el.checked=true;        
         // _processCompareCheckbox(el);
        });
      }
      else {
        const elCompare=document.querySelector('[data-compare-id="'+x+'"]');        
          var type = $(elCompare).attr('data-type');
           $('.compare-checkbox').each(function() {
            if($(this).attr('data-type') != type) {
              $(this).parent().hide();
            } else {
              $(this).parent().show();
            }
          });        
      }
    });

    var compare_count = compareItems.length;
    if (compare_count>0) {
      $('.compare-checkbox__tool-tip span').text(compare_count);
      $('.compare-slide__button span').text('(' + compare_count + ')');
      $('.compare-slide').addClass('compare-slide--active');
      $('.copyright').addClass('copyright--compare-active');
      if (compare_count > 1) {
        $('.compare-slide__add-more').hide();
        $('.compare-slide__button').show();
      } else {
        $('.compare-slide__add-more').show();
        $('.compare-slide__button').hide();
      }   
    }   
  }
  $('.compare-checkbox').off('change').on('change', function() {    
    const comparePanel = $('.compare-slide');
    const backBtn = $('.back-to-top');

    if (comparePanel.hasClass('minimized')) {
      // Temporarily show the panel
      comparePanel.removeClass('minimized');
      backBtn.removeClass('lifted');

      // Optional: re-minimise after a delay
      setTimeout(() => {
        // Only re-minimise if localStorage still says it was minimized
        if (localStorage.getItem('panelMinimized') === 'true') {
          comparePanel.addClass('minimized');
          backBtn.addClass('lifted');
        }
      }, 3000);
    }

    const _handler=$(this).data('product-id');
    let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');
      const els=document.querySelectorAll('[data-product-id="'+_handler+'"].compare-checkbox');
      const originalEl=this;
        els.forEach(el => {          
            el.checked=originalEl.checked;                            
        })
    
    if (this.checked) {
      compareItems.push(_handler);
      addCompare(_handler);
    }
    else {
      compareItems=compareItems.filter(item => item !== _handler);
      document.querySelector('[data-compare-id="'+_handler+'"]').remove();
    }
    sessionStorage.setItem('comparelist',JSON.stringify(compareItems));
    _processCompareCheckbox(this);
  });
  // Add keydown event listener to checkboxes to handle Enter key
  $('.compare-checkbox').off('keydown').on('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default enter key behavior
      $(this).prop('checked', !$(this).prop('checked')).trigger('change');
    }
  });
}

// VAT Toggle
function initVatToggle() {
  // If <html> has class 'vat-toggle-off', force VAT preference to 'on'
  if (document.documentElement.classList.contains('vat-toggle-off')) {
    applyVatToggleOff();
    sessionStorage.setItem('vatPreference', 'on');
  } else {
    // Check stored VAT preference or default to 'on' if none exists
    const vatPreference = sessionStorage.getItem('vatPreference') || 'off';
    
    if (vatToggleProductPageOnly) {
      applyVatToggleOff();
    } else {
      if (vatPreference === 'off') {
        applyVatToggleOff();
      } else {
        applyVatToggleOn(); // Default to 'on'
      }
    }
  }

  // VAT Display Toggle On
  $('.vat-toggle--on').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      applyVatToggleOn();
      sessionStorage.setItem('vatPreference', 'on');
    }
  });

  // VAT Display Toggle Off
  $('.vat-toggle--off').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      applyVatToggleOff();
      sessionStorage.setItem('vatPreference', 'off');
    }
  });

  $('#vatToggle').off('change').on('change', function () {
    if (this.checked) {
      applyVatToggleOff();
      sessionStorage.setItem('vatPreference', 'off');
    } else {
      applyVatToggleOn();
      sessionStorage.setItem('vatPreference', 'on');
    }
  });
  $('.vat-toggle-label').off('keydown').on('keydown', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault(); // prevent scrolling for space
      $('#vatToggle').trigger('click');
    }
  });
}

function applyVatToggleOn() {

  $('.vat-toggle--on').hide();
  $('.vat-toggle--off').show();

  // Canvas Cart
  $('.canvas-price-no-vat').hide();
  $('.canvas-price-vat').show();
  
  // Hero Grid
  $('.hero-grid__product-vat-relief').hide();
  $('.hero-grid__product-no-vat-relief').show();

  // Featured Products
  $('.featured-products__product-vat-relief').hide();
  $('.featured-products__product-no-vat-relief').show();
  
  // Product Card / General
  $('.product-card__vat-relief').hide();
  $('.product-card__no-vat-relief').show();
  
  // Product Card Sale Badge
  $('.product-card__badge-vat-relief').hide();
  $('.product-card__badge-no-vat-relief').show();

  // Nav Products
  $('.nav-products__vat-relief').hide();
  $('.nav-products__no-vat-relief').show();

  // Add Ons
  $('.product-add-ons__card-vat-relief').hide();
  $('.product-add-ons__card-no-vat-relief').show();

  $('.variant__delivery-vat-relief').hide();
  $('.variant__delivery-no-vat-relief').show();
  
  // Configured Products
  $('.configured__vat-relief').hide();
  $('.configured__no-vat-relief').show();  
  updateConfiguredPrice();

  // Product Page
  $('body').addClass('vat-relief-off');
  $('body').removeClass('vat-relief-on');
  $('.product-price__vat-relief').hide();
  $('.product-price__no-vat-relief').show();
  $('.discount--vat-relief').hide();
  $('.discount--no-vat-relief').show();
  if (document.body.classList.contains('template-product') || window.location.pathname.includes('/products/')) {
    const vprice = window.vprice;
    // PAYPAL MESSAGING
    const ppContainer = document.querySelector('[data-pp-message]');
    if (ppContainer) {
      ppContainer.setAttribute('data-pp-amount', vprice / 100);
    }
  }

  // Cart
  $('.cart .cart-item__vat-relief').hide();
  $('.cart .cart-item__no-vat-relief').show();  
  
  // Slide Out Cart
  var slide_total = 0;
  $('.canvas-cart .canvas-cart-item').each(function() {
    var slide_price_standard = $(this).find('.cart-prod-price .cart-prod-price--now:visible').eq(0).text().replace('£','').replace(',','');
    var slide_qty = $(this).find('.quantity-value').eq(0).text();
    slide_total += Number(slide_price_standard) * Number(slide_qty);
  });
  $('.canvas-cart .mini-cart-total').text(formatMoney(slide_total * 100, currencySymbol +  "\{\{amount\}\}"));
  
}

function applyVatToggleOff() {
  
  $('.vat-toggle--off').hide();
  $('.vat-toggle--on').show();

  // Canvas Cart
  $('.canvas-price-no-vat').show();
  $('.canvas-price-vat').hide();
  
  // Hero Grid
  $('.hero-grid__product-vat-relief').show();
  $('.hero-grid__product-no-vat-relief').hide();

  // Featured Products
  $('.featured-products__product-vat-relief').show();
  $('.featured-products__product-no-vat-relief').hide();
  
  // Product Card
  $('.product-card__vat-relief').show();
  $('.product-card__no-vat-relief').hide();

  // Product Card Sale Badge
  $('.product-card__badge-vat-relief').show();
  $('.product-card__badge-no-vat-relief').hide();

  // Nav Products
  $('.nav-products__vat-relief').show();
  $('.nav-products__no-vat-relief').hide();

  // Add Ons
  $('.product-add-ons__card-vat-relief').show();
  $('.product-add-ons__card-no-vat-relief').hide();

  $('.variant__delivery-vat-relief').show();
  $('.variant__delivery-no-vat-relief').hide();
  
  // Configured Products
  $('.configured__vat-relief').show();
  $('.configured__no-vat-relief').hide();
  updateConfiguredPrice();
  
  // Product Page
  $('body').removeClass('vat-relief-off');
  $('body').addClass('vat-relief-on');
  $('.product-price__vat-relief').show();
  $('.product-price__no-vat-relief').hide();
  $('.discount--vat-relief').show();
  $('.discount--no-vat-relief').hide();
  if (document.body.classList.contains('template-product') || window.location.pathname.includes('/products/')) {
    const vprice = window.vprice;
    // PAYPAL MESSAGING
    const ppContainer = document.querySelector('[data-pp-message]');
    if (ppContainer) {
      ppContainer.setAttribute('data-pp-amount', (vprice / 1.2) / 100);
    }
  }

  // Cart
  $('.cart .cart-item__vat-relief').show();
  $('.cart .cart-item__no-vat-relief').hide();

  // Slide Out Cart
  var slide_total = 0;
  $('.canvas-cart .canvas-cart-item').each(function() {
    var slide_price_standard = $(this).find('.cart-prod-price .cart-prod-price--now:visible').eq(0).text().replace('£','').replace(',','');
    var slide_qty = $(this).find('.quantity-value').eq(0).text();
    slide_total += Number(slide_price_standard) * Number(slide_qty);
  });
  $('.canvas-cart .mini-cart-total').text(formatMoney(slide_total * 100, currencySymbol +  "\{\{amount\}\}"));

}

// Initialize the VAT toggle logic when the document is ready
$(document).ready(function () {
  initVatToggle();
});

// Subscribe Popup
document.addEventListener("DOMContentLoaded", function() {
  const popup = document.querySelector(".subscribe-popup");
  if (!popup) return; // Exit if .subscribe-popup is not on the page

  // Function to show the popup
  function showPopup() {
    popup.style.display = "block";
    
    const closeButton = popup.querySelector(".subscribe-popup__close");
    if (closeButton) {
      closeButton.addEventListener("click", function() {
        popup.style.display = "none";
        localStorage.setItem('popupLastClosed', Date.now());
      });
    }
  }

  // Function to check if the popup should be shown
  function shouldShowPopup() {
    const lastClosed = localStorage.getItem('popupLastClosed');
    if (!lastClosed) {
      return true; // No record of it being shown before
    }
    const hoursSinceLastClose = (Date.now() - lastClosed) / (1000 * 60 * 60);
    return hoursSinceLastClose >= 24;
  }

  // Show the popup if it's been more than 24 hours since it was last closed
  if (shouldShowPopup()) {
    showPopup();
  }
});

// Page Form HTML Submit
$('input,select','[data-vatform]').on('change',function() {
  const el=this;
  if ($(el).is(":visible")) {
    const validator=$(el).next('.form__validation');
    if (validator.length == 1) {
      if (el.value == '') {
        validator.show();
        isValid=false;
      }
      else {
        validator.hide();
      }
    }
  }
});

$('[data-vatform-submit]').on('click', function() {
  // Validate Form
  loader(true);
  let isValid=true;
  $('input,select','[data-vatform]').each(function(inx,el) {
    if ($(el).is(":visible")) {
      const validator=$(el).next('.form__validation');
      if (validator.length == 1) {
        if (el.value == '') {
          validator.show();
          isValid=false;
        }
        else {
          validator.hide();
        }
      }
    }
  });
  if (!isValid) return false;
  // Save Data
  let formData={};
  $('#accept_cookies').val(Shopify.customerPrivacy.getTrackingConsent()=='yes'?"Yes":"No");
  $('input,select,textarea','[data-vatform]').each(function(inx,el) {
    if (el.id !='' && (el.type == 'textarea' || el.type == 'text' || el.type=='hidden' || el.type == 'email' || el.type == 'select-one')) {
      formData[el.id]=el.value;
    }
    else if (el.id !='' && (el.type == 'radio' && el.checked)) {
      formData[el.id]=el.value;      
    }
    else if (el.id !='' && (el.type == 'checkbox')) {
      formData[el.id]=el.checked?"Yes":"No";      
    }
  })    
  
  const d = formData;
  const params =new URLSearchParams(document.location.search);
  const orderid=params.get("218763");
  const _formResponse = {  
    "Who are you claiming VAT relief for?": d.myself || d.somebody_else,
    "First Name of person claiming VAT": d.first_name,
    "Last Name of person claiming VAT": d.last_name,
    "Address": d.address,
    "City": d.city,
    "County / Region": d.county_region,
    "Postcode": d.postcode,
    "Your disability": d.disability,
    "Describe your condition": d.describe_your_condition ,
    "I would like to receive an email copy of my submitted VAT declaration": d.receive_email_checkbox,
    "Email address for confirmation email": d.customer_email,
    "Accept Cookies":d.accept_cookies,
    "Order ID": orderid?parseInt(orderid)/624:''
  };
  fetch(`https://formbuilder.hulkapps.com/forms/create_response/${FormID}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Form-Access-Token": accessToken
    },
    body: JSON.stringify({formResponse:_formResponse})
  })
  .then(response => response.json())
  .then(data => {
    loader(false);
    $('form','[data-vatform]').hide();
    $('.cart-vat__thanks').show();
  })
  .catch(error => {
    loader(false);
    console.error("Error submitting form:", error);
  });
  return false;
});


if (window.location.href.includes("/cart")) {

if (sessionStorage.getItem("__vr1")!=null) {
  document.querySelectorAll('[data-vatform-success]').forEach(x=> x.style.display = x.style.display=='none'?x.dataset.vatformSuccess:'none');
  $('#vat_relief').addClass('cart-vat--hidden');
  $('#vat_relief').hide();
  $('#vat_success').show();      
}
else {    
  $('#vat_relief').show();
}
// CART VAT RELIEF FORM
$('.form__validation','[data-vatform-main]').hide();
// Form HTML Submit
$('[data-vatform-main-submit]').on('click', function() {
  // Validate Form
  let isValid=true;
  $('input,select','[data-vatform-main]').each(function(inx,el) {
    if ($(el).is(":visible")) {
      const validator=$(el).next('.form__validation');
      if (validator.length == 1) {
        if (el.value == '') {
          validator.show();
          isValid=false;
        }
        else {
          validator.hide();
        }
      }
    }
  });
  if (!isValid) return false;
  // Save Data
  let formData={};
  $('#accept_cookies').val(Shopify.customerPrivacy.getTrackingConsent()=='yes'?"Yes":"No");
  $('input,select,textarea','[data-vatform-main]').each(function(inx,el) {
    if (el.id !='' && (el.type == 'textarea' || el.type == 'email' || el.type == 'hidden' || el.type == 'text' || el.type == 'select-one')) {
      formData[el.id]=el.value;
    }
    else if (el.id !='' && (el.type == 'radio' && el.checked)) {
      formData[el.id]=el.value;      
    }
    else if (el.id !='' && (el.type == 'checkbox')) {
      formData[el.id]=el.checked?"Yes":"No";      
    }
  })    
  sessionStorage.setItem("__vr1", btoa(JSON.stringify(formData)));
  recalculateCart();
  //
  document.querySelectorAll('[data-vatform-success]').forEach(x=> x.style.display = 'none');
  $('#vat_relief').addClass('cart-vat--hidden');
  $('#vat_relief').hide();
  $('#vat_success').show();
  $('.cart-summary__vat').show();
  $('.cart-vat__popup').removeClass('cart-vat__popup--active');
  $('html').removeClass('noscroll-popup');
  $('html').scrollTop(0);
  return false;
});
 
// Remove VAT Relief
document.querySelectorAll("[data-action='removevatRelief']").forEach(element => {
  element.addEventListener('click',function() {
    sessionStorage.removeItem("__vr1");       
    document.location='/cart';    
  });
});

// Edit VAT Relief
function getAllProperties(obj) {
  let props = new Set();
  while (obj) {
    Object.getOwnPropertyNames(obj).forEach(p => props.add(p));
    obj = Object.getPrototypeOf(obj);
  }
  return [...props];
}
let isEditLoaded=false;
document.querySelectorAll('[data-action="editvatRelief"]').forEach(element => {
  element.addEventListener('click',function() {     
    if (!isEditLoaded) {
    const formData = JSON.parse(atob(sessionStorage.getItem("__vr1")));
    getAllProperties(formData).forEach(x=> {
      const el=document.getElementById(x);
      if (el) {
        if (el.type == 'textarea' || el.type == 'text' || el.type == 'email' || el.type == 'select-one') {
          el.value=formData[x];          
        }
        else if (el.type == 'checkbox') {
          el.checked=formData[x]=="Yes";      
        }
        else {
          el.checked=true;
          el.click();
        }
      }
    });
    isEditLoaded=true;
    }
    $('[data-vatform-main]').show();
    $('#vat_relief').show();
    $('.cart-vat__footer').hide();
    $('.cart-vat__popup').addClass('cart-vat__popup--active');
    $('html').addClass('noscroll-popup');
    $('.cart-vat__panel--top').hide();
    $('.cart-vat__panel--form').addClass('cart-vat__panel--form--hidden');
    $('.cart-vat__hover-wrap').removeClass('cart-vat__hover-wrap--active');
  });
}); 

// Popup - Close
$('.cart-vat__popup-close').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    $('.cart-vat__popup').removeClass('cart-vat__popup--active');
    $('html').removeClass('noscroll-popup');
  }
});

// Popup - Close Outside Panel
$('.cart-vat__popup-panel').click(function(event) {
  event.stopPropagation(); // Prevent the click event from reaching .popup
});
$('.cart-vat__popup').click(function() {
  $('.cart-vat__popup').removeClass('cart-vat__popup--active');
  $('html').removeClass('noscroll-popup');
});

// Submit Form
$('[data-checkout-button]').on('click',function() {
  $('a.button,button').addClass('disabled');
  $('[data-checkout-button] svg').attr('data-icon','spinner');
  loader(true);  
  submitVatForm();
  return false;
});

function submitVatForm() {

  
  const formDataLocal = sessionStorage.getItem("__vr1");
  if (formDataLocal == null) {
    document.location="/checkout";
    return false;
  }
  
  const d = JSON.parse(atob(formDataLocal));
  const _formResponse = {  
    "Who are you claiming VAT relief for?": d.myself  || d.somebody_else,
    "First Name of person claiming VAT": d.first_name,
    "Last Name of person claiming VAT": d.last_name,
    "Address": d.address,
    "City": d.city,
    "County / Region": d.county_region,
    "Postcode": d.postcode,
    "Your disability": d.disability,
    "Describe your condition": d.describe_your_condition,
    "I would like to receive an email copy of my submitted VAT declaration": d.receive_email_checkbox,
    "Email address for confirmation email": d.customer_email,
    "Accept Cookies":d.accept_cookies
  };

    var formDataCartVAT = new FormData();
    formDataCartVAT.append('attributes[VAT_Relief]', 'true');

    fetch('/cart/update.js', {
      method: 'POST',
      body:formDataCartVAT
    }).then(response => {
      if (response.ok) {
  fetch(`https://formbuilder.hulkapps.com/forms/create_response/${FormID}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Form-Access-Token": accessToken
    },
    body: JSON.stringify({formResponse:_formResponse})
  })
  .then(response => response.json())
  .then(data => {
    const formId=data.submission_number;
    var formDataCart = new FormData();
    formDataCart.append('attributes[VAT_Relief_ID]', formId);

    fetch('/cart/update.js', {
      method: 'POST',
      body:formDataCart
    }).then(response => {
      if (response.ok) {
        document.location="/checkout";
      }  
    })
})
.catch(error => {
  console.error("Error submitting form:", error);
});
      }  
    
    });

}

// Catalogue limit of 1
document.addEventListener('DOMContentLoaded', () => {
  const catalogueSku = 'CATALOGUE'; // your SKU

  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // find the line item by SKU
      const item = cart.items.find(i => i.sku === catalogueSku);
      if (item && item.quantity > 1) {
        // use the variant_id from that item
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: { [item.variant_id]: 1 } })
        })
        .then(r => r.json())
        .then(updatedCart => console.log('Quantity forced to 1', updatedCart))
        .catch(err => console.error('Cart update error:', err));
      }
    });
});

}

// Compare Functions 
if (window.location.href.includes("pages/compare")) {

  document.querySelectorAll('[data-compare-share]').forEach(button => {
    button.addEventListener('click', function() {
      let compareItems = JSON.parse(sessionStorage.getItem('comparelist') || '[]');  
      if (compareItems.length > 0) {
        const shareUrl = new URL(window.location.pathname, window.location.origin);
        shareUrl.searchParams.set("q", compareItems.join(","));
        const shareLink = shareUrl.toString();
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(shareLink).select();
        document.execCommand("copy");
        $temp.remove();
        const $span = $(this).children('span');
        const originalText = $span.text();

        $span.text('Link copied');
        
        setTimeout(() => {
          $span.text(originalText);
        }, 2000);
      }
    });
  });
  
  let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');  
   if (document.location.search != "") {
      const params = new URLSearchParams(document.location.search);
      const q = params.get("q");
      if (q) {
        compareItems=q.split(',');
        sessionStorage.setItem('comparelist',JSON.stringify(compareItems));
      }
    }
  if (compareItems.length>0) {
    loadCompareItem(compareItems[0]);
  }
  else {
    $('.compare').addClass('compare--empty');
  }

  function loadCompareItem(x) {
    $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+x+"/?view=compare",        
      success: function (data) {
        const _html=new DOMParser().parseFromString(data, 'text/html').body;         
        document.querySelectorAll('.compare__table tr').forEach((t,inx)=> {            
          const _td=document.createElement('td');
          _td.innerHTML=_html.querySelectorAll('row')[inx].innerHTML;
          if (inx==0) {
            _td.querySelector("[data-action='compare-remove']").addEventListener('click',function() {
              let compareItems=JSON.parse(sessionStorage.getItem('comparelist') || '[]');
              const id  =this.dataset.compareId;
              compareItems=compareItems.filter(item => item !== id);             
              sessionStorage.setItem('comparelist',JSON.stringify(compareItems));
              document.location='/pages/compare';
            });
          }
          t.appendChild(_td);  
        });
        compareItems=compareItems.filter(c=>c!=x);
        if (compareItems.length>0) {
          loadCompareItem(compareItems[0]);
        }
        else {
          //more link
          const type=document.querySelector('[data-compare-type]').dataset.compareType;
          const morelink=document.querySelector('.compare__more-panel');
          morelink.href = '/collections/' + type.replace(/ /g, '-').toLowerCase();
          morelink.innerHTML="More "+type.toLowerCase()+morelink.innerHTML;
          //swatches
          loadswatches();
          //add to cart
          document.querySelectorAll('[data-add-to-cart-product]').forEach(element => {
            element.addEventListener('click',function() {
              addItemToCart(this.dataset.addToCartProduct,1);
            });
          });
		      
          document.querySelector('.compare__main').style.display='flex';
          $('tr').each(function() {
            let isData=false;
            $('td',this).each(function() {
              let _dataText=$('<div></div>');
              _dataText.html(this.innerHTML+'');
              _dataText.find('span.compare__table-label').remove();
              if (_dataText.get(0).innerHTML.trim()!='') {
                isData=true;
              }
            });
            if (!isData) $(this).remove()
          });    

          // Log the total number of table rows after rendering
          const totalRows = document.querySelectorAll('.compare__table tr').length;
          if (totalRows > 1) {
            const secondToLastRowIndex = totalRows - 1; // Get index of the second-to-last row
            const secondToLastRow = document.querySelectorAll('.compare__table tr')[secondToLastRowIndex - 1];

            // Determine if it's even or odd and add the class
            const className = secondToLastRowIndex % 2 === 0 ? "even" : "odd";
            secondToLastRow.classList.add(className);
          }

          // Compare Page - Show/Hide Variants
          $('.compare__product-select').on('change', function() {
            var optionSelected = $(this).find("option:selected");
            var productSelected = optionSelected.attr('data-product');
            var variantSelected = optionSelected.val();
            var variantIdSelected = optionSelected.attr('data-variant');
            $('div[data-product="' + productSelected + '"]').hide();
            $('div[data-value="' + variantSelected + '"]').show();
            $('[data-product-handler="'+productSelected+'"] [data-add-to-cart-product]').attr('data-add-to-cart-product',variantIdSelected);
          });
        }
      }
    });
  }  
}

// CONFIGURED ADD-ONS
$('.configured__variant').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    $(this).parent().children().removeClass('configured__variant--selected');
    $(this).addClass('configured__variant--selected');
    updateConfiguredPrice();
  }
});

// PRODUCT ADD-ONS
$('.product-add-ons__title').off('click keydown').on('click keydown', function (event) {
  if (event.type === 'click' || event.key === 'Enter') {
    let $this = $(this);
    let isExpanded = $this.attr('aria-expanded') === 'true';
    // Toggle aria-expanded attribute
    $this.attr('aria-expanded', !isExpanded);
    $(this).next().slideToggle(200);
    $(this).children().toggle();
  }
});

document.querySelectorAll('[data-addon-product]').forEach(element => {
  element.addEventListener('click',function() {
    addItemToCart(this.dataset.addonProduct,1);
  });
});

function updateConfiguredPrice() {
  var colourText = '';

  if ($('.product-swatches').length > 0) {
    var colourText = $('.product-swatches').attr('data-current-colour');
  }
  var variantText = '';
  $('.variant-option').each(function() {
    var $input = $(this).find('.variant__radio--standard:checked');
    var $select = $(this).find('.variant__select');

    if ($input.length > 0) {
      if($input.val() != "Default Title") {
        if (variantText === '') {
          variantText = $input.val();
        } else {
          variantText += ', ' + $input.val();
        }
      }
    } 
    else if ($select.length > 0) {
      var selectedOption = $select.val();
      if(selectedOption != "Default Title") {
        if (selectedOption) {
          if (variantText === '') {
            variantText = selectedOption;
          } else {
            variantText += ', ' + selectedOption;
          }
        }
      }
    }
  });

  var configuredVariantText = '';
  $('.configured__variant--selected').each(function() {
    if(configuredVariantText == '') {
      if($(this).hasClass('configured__variant--without')) {
        configuredVariantText = $(this).children().text();
      } else {
        configuredVariantText = $(this).children().children('.configured__variant-title').text();
      }
    } else {
      if($(this).hasClass('configured__variant--without')) {
        configuredVariantText = configuredVariantText + ', ' + $(this).children().text();
      } else {
        configuredVariantText = configuredVariantText + ', ' + $(this).children().children('.configured__variant-title').text();
      }
    }
  });
  var optionCount = 0;
  if(configuredVariantText.length > 0) {
    var optionCount = optionCount + 1;
    var configuredVariantText = '<span>' + configuredVariantText + '</span>';
  }
  var deliveryText = '';
  if ($('.variant__delivery-radio').length > 0) {
    var optionCount = optionCount + 1;
    var deliveryText = $('.variant__delivery-radio:checked').val();
    deliveryText = '<span>' + deliveryText + '</span>';
  }
  var variantTextFinal = ''
  if(variantText) {
    var optionCount = optionCount + 1;
    var variantTextFinal = '<span>' + variantText + '</span>';
  }
  var colourTextFinal = ''
  if(colourText) {
    var optionCount = optionCount + 1;
    var colourTextFinal = '<span>' + colourText + '</span>';
  }
  var summaryText = colourTextFinal + variantTextFinal + configuredVariantText + deliveryText;
  var labelText = "Selected:";

  if(optionCount > 1) {
    $('.product-summary--standard').removeClass('product-summary--empty');
    $('.product-summary-label').removeClass('product-summary--empty');
    $('.product-summary--standard').html(summaryText);
    $('.summary__label').html(labelText);
  } else {
    if (variantText.includes(",")) {
      $('.product-summary--standard').removeClass('product-summary--empty');
      $('.product-summary-label').removeClass('product-summary--empty');
      $('.product-summary--standard').html(summaryText);
      $('.summary__label').html(labelText);
    } else {
      $('.product-summary--standard').addClass('product-summary--empty');
      $('.product-summary-label').addClass('product-summary--empty');
      $('.product-summary--standard').html('');
      $('.summary__label').html('');
    }
  }
  
  let addPrice=0;
  let exVATaddPrice=0;
  let addPricePP=0;

  $('[data-addon-id].configured__variant--selected .configured__variant-price span:visible').each(function() {
    addPrice+=parseFloat($(this).text().substr(1),2)*100;
    exVATaddPrice+=parseFloat($(this).text().substr(1),2)*100;
  });

  $('input:checked[data-variant-id]').each(function() {
    addPrice+=parseFloat($(this).parent().find('.variant__delivery-price:visible').text().trim().substr(2),2)*100;
    exVATaddPrice+=parseFloat($(this).parent().find('.variant__delivery-price.variant__delivery-no-vat-relief').text().trim().substr(2),2)*100;
    addPricePP+=parseFloat($(this).parent().find('.variant__delivery-price:visible').text().trim().substr(2),2);

    // PAYPAL MESSAGING
    /*
    const ppContainer = document.querySelector('[data-pp-message]');
    if (ppContainer) {
      $('[data-pp-amount]').each(function() {
        $(this).attr('data-pp-amount', (parseFloat($(this).attr('data-pp-amount'))+addPricePP).toFixed(10));
      });
    }
    */
  });

  $('[data-updateprice]').each(function() {
    $(this).text(Shopify.formatMoney(parseFloat($(this).attr('data-updateprice'),2)+addPrice,shopifyMoneyFormat) );
  });
  $('.price-inc-vat[data-updateprice]').each(function() {
    $(this).text(Shopify.formatMoney(parseFloat($(this).attr('data-updateprice'),2)+exVATaddPrice,shopifyMoneyFormat) );
  });
  $('[data-updateprice3]').each(function() {
    $(this).text(Shopify.formatMoney((parseFloat($(this).attr('data-updateprice3'),2)+addPrice)/3,shopifyMoneyFormat) );
  });
}

// BREADCRUMB SCROLL RIGHT ON PAGE LOAD
window.addEventListener('load', () => {
  const scrollableElement = document.getElementById('breadcrumb_scrollable');
  if (scrollableElement) {
    scrollableElement.scrollLeft = scrollableElement.scrollWidth;
  }
});

// CART DISCOUNT
function updateCartDiscount(discountCode) {
  const cartId=getCookie('cart') ? `gid://shopify/Cart/${getCookie('cart')}` : '';
  const getBundleVariantIds = function() {
    const bundleVariantIds = [];
    document.querySelectorAll('[data-cartitem] .badge--bundle').forEach(function(bundleBadge) {
      const cartItem = bundleBadge.closest('[data-cartitem]');
      const quantityInput = cartItem ? cartItem.querySelector('[data-cart-qty]') : null;
      const variantId = quantityInput ? parseInt(quantityInput.getAttribute('data-cart-qty'), 10) : NaN;
      if (!isNaN(variantId) && !bundleVariantIds.includes(variantId)) {
        bundleVariantIds.push(variantId);
      }
    });
    return bundleVariantIds;
  };
  const normalizeProperties = function(properties) {
    const normalizedProperties = {};
    if (!properties) return normalizedProperties;
    Object.keys(properties).sort().forEach(function(key) {
      const value = properties[key];
      if (value !== null && value !== undefined && value !== '') {
        normalizedProperties[key] = value.toString();
      }
    });
    return normalizedProperties;
  };
  const linePropertiesMatch = function(firstItem, secondItem) {
    return JSON.stringify(normalizeProperties(firstItem.properties)) == JSON.stringify(normalizeProperties(secondItem.properties));
  };
  const cartQuantityForLine = function(cart, item) {
    if (!cart || !cart.items) return 0;
    return cart.items.filter(function(cartItem) {
      return cartItem.variant_id == item.variant_id && linePropertiesMatch(cartItem, item);
    }).reduce(function(totalQuantity, cartItem) {
      return totalQuantity + cartItem.quantity;
    }, 0);
  };
  const bundleVariantIds = getBundleVariantIds();
  const hasBundleInCart = bundleVariantIds.length > 0;
  const runCartDiscountUpdate = function(bundleCartBeforeDiscount) {
    const _var={
      cartId:cartId,
      discountCodes:discountCode ? [discountCode] : []
    };
    FetchDataWithVariables(`
      mutation cartDiscountCodesUpdate($cartId: ID!, $discountCodes: [String!]!) {
        cartDiscountCodesUpdate(cartId: $cartId, discountCodes: $discountCodes) {
          cart {
            id
            discountCodes {
              code
            }
          }
          userErrors {
            field
            message
          }
        }
      }
      `,_var,function(data) {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const itemsBeforeDiscount = bundleCartBeforeDiscount && bundleCartBeforeDiscount.items ? bundleCartBeforeDiscount.items : [];
            const itemsToRestore = hasBundleInCart ? itemsBeforeDiscount.filter(function(itemBeforeDiscount) {
              return bundleVariantIds.includes(itemBeforeDiscount.variant_id) && cartQuantityForLine(cart, itemBeforeDiscount) < itemBeforeDiscount.quantity;
            }) : [];

            if (itemsToRestore.length > 0) {
              fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  items: itemsToRestore.map(function(item) {
                    const quantity = item.quantity - cartQuantityForLine(cart, item);
                    const restoreItem = {
                      id: item.variant_id.toString(),
                      quantity: quantity
                    };
                    if (item.properties && Object.keys(item.properties).length > 0) {
                      restoreItem.properties = item.properties;
                    }
                    return restoreItem;
                  })
                })
              })
              .then(response => response.json())
              .then(() => {
                _updateCartContent(discountCode!=''?true:false);
              })
              .catch(() => {
                _updateCartContent(discountCode!=''?true:false);
              });
              return;
            }

            _updateCartContent(discountCode!=''?true:false);
          })
          .catch(() => {
            _updateCartContent(discountCode!=''?true:false);
          });
      }
    );
  };

  if (cartId != '' )  {
    if (hasBundleInCart) {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          runCartDiscountUpdate(cart);
        })
        .catch(() => {
          runCartDiscountUpdate(null);
        });
    }
    else {
      runCartDiscountUpdate(null);
    }
  }
}

document.querySelectorAll('[data-action="discountcode"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount(document.querySelector('[data-discountcode]').value);
  });
});

document.querySelectorAll('[data-action="discountremove"]').forEach(element => {
  element.addEventListener('click',function() {
    updateCartDiscount('');
    $('#discount').val('');
  });
});

// SKIP TO CONTENT
/*
document.getElementById('skip-link').addEventListener('click', function(event) {
  event.preventDefault(); // Prevent default anchor behavior
  const mainContent = document.getElementById('maincontent');

  // Find first focusable element inside #maincontent
  const focusableElements = mainContent.querySelectorAll('a, button, input, textarea, select, [tabindex]:not([tabindex="-1"])');

  if (focusableElements.length > 0) {
    focusableElements[0].focus(); // Move focus to first interactive element
  } else {
    mainContent.setAttribute('tabindex', '-1'); // Ensure it's focusable
    mainContent.focus(); // Move focus to the main content
  }
});
*/

// SKIP TO FIRST H1 OR MAINCONTENT
document.querySelectorAll('#skip-link, #skip-link-basket').forEach(function(el) {
  el.addEventListener('click', function(event) {
    event.preventDefault(); // Prevent default anchor behavior

    // Close basket overlay if this is the basket skip link
    if (el.id === 'skip-link-basket') {
      $('.header-basket').removeClass('header-basket--active');
      $('.header').removeClass('header--sticky');
      $('.canvas-cart__container').blur(); // remove focus from basket
    }

    // Try to find the first H1
    let target = document.querySelector('h1');

    // Fallback to #maincontent if no H1
    if (!target) {
      target = document.getElementById('maincontent');
      if (!target) return; // Exit if neither exists
    }

    // Make it focusable
    target.setAttribute('tabindex', '-1');
    target.focus();

    // Scroll smoothly to it
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

// RECENTLY VIEWED
/*
const recentSettings={
  storeNumber:8
}
function recordRecentView() {
  if (-1 !== window.location.pathname.indexOf("/products/")) {
    let recentItems=JSON.parse(localStorage.getItem('recentlist') || '[]');
    let r = window.location.pathname.match(/\/products\/([a-z0-9\-\_]+)/)[1];
    if (!recentItems.includes(r)) {
      recentItems.unshift(r);
      recentItems = recentItems.splice(0,recentSettings.storeNumber); 
      localStorage.setItem('recentlist',JSON.stringify(recentItems));
    }    
  }
}
*/
function showRecentView() {
  let recentItems=JSON.parse(localStorage.getItem('recentlist') || '[]');
  if (recentItems.length>0) {
    loadRecentItem(recentItems[0]);
  }

  function loadRecentItem(x) {
    $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+x+"/?view=card",        
      success: function (data) {
        const _html=new DOMParser().parseFromString(data, 'text/html');   
        const _p=document.createElement('div');
        _p.innerHTML=_html.querySelector('[data-product-obj]').innerHTML;
        _p.setAttribute('data-product-obj',_html.querySelector('[data-product-obj]').getAttribute('data-product-obj'));
        var colClass = $('[data-container="recent"]').attr('data-col-class');
        _p.className=colClass;
        if (-1 !== window.location.pathname.indexOf("/products/")) {    
           if (x != window.location.pathname.match(/\/products\/([a-z0-9\-\_]+)/)[1]) {
              document.querySelector('[data-container="recent"]').appendChild(_p);               
           }
        }
        else {
          document.querySelector('[data-container="recent"]').appendChild(_p);            
        }
        recentItems=recentItems.filter(c=>c!=x);
        if (recentItems.length>0) {
          loadRecentItem(recentItems[0]);
        }  
        else {
          if ($('[data-container="recent"] [data-product-obj]').length>0) {
            $(".recently-viewed").show();
            $(".recently-viewed").removeClass('recently-viewed--hidden');
            _initCompare();
            loadswatches(true);
          }
        }
      }
    });
  } 
}

// CART QUOTE REQUEST LINK
function updateMailtoLink() {
  const quoteContent = document.querySelector('#quote-content');
  if (!quoteContent) return;

  let bodyContent = quoteContent.innerText.trim();
  bodyContent = encodeURIComponent(bodyContent);

  const mailtoHref = `mailto:info@manageathome.co.uk?subject=Quote Request&body=${bodyContent}`;
  document.querySelector('.cart-quote__link').href = mailtoHref;
}

// Initialize MutationObserver to watch for changes
function observeContentChanges() {
  const targetNode = document.querySelector('#quote-content');
  if (!targetNode) return;

  const observer = new MutationObserver(() => updateMailtoLink());

  observer.observe(targetNode, {
    childList: true,      // Watch for changes to child elements
    subtree: true,        // Watch all descendant elements
    characterData: true,  // Watch for text changes
  });

  // Initial call to set the mailto link
  updateMailtoLink();
}

// Start observing when DOM is fully loaded
document.addEventListener('DOMContentLoaded', observeContentChanges);

// Close Header-Basket Active
$(document).on("click", function (event) {
  let $basket = $(".header-basket");
  // If clicking outside the basket
  if (!$(event.target).closest(".header-basket").length) {
    $basket.removeClass("header-basket--active");
  }
});

// Close Header-Basket Active on scroll more than 100px
let lastScrollTop = 0;
$(window).on("scroll", function () {
  let scrollTop = $(this).scrollTop();
  if (scrollTop > 100 && Math.abs(scrollTop - lastScrollTop) > 10) {
    $(".header-basket").removeClass("header-basket--active");
  }
  lastScrollTop = scrollTop;
});

// Globo Form - Auto Populate
$(document).ready(function () {
  var declare_text = $('#paragraph-1 span').text();
  $('#paragraph-1 span').append('<strong class="underline" style="font-family: Arial;">_________________</strong>')
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  function populateFields() {
    const orderId = getQueryParam('order-id');
    const fname = getQueryParam('fname');
    const lname = getQueryParam('lname');
    
    if (orderId) $('.order-id input').val(orderId);
    if (fname) $('.fname input').val(fname);
    if (lname) $('.lname input').val(lname);
  }
  
  function waitForForm() {
    if ($('.order-id input').length && $('.fname input').length && $('.lname input').length) {
      populateFields();
    } else {
      setTimeout(waitForForm, 500);
    }
  }
  waitForForm();
  // Show 'describe-your-condition' textarea when 'Other' is selected
  $(document).on('change', '.globo-form-control.disability-selector select', function () {
    if ($(this).val() === 'Other') {
      $('.describe-your-condition').show();
      var other_text = declare_text.replace(" by reason of","");
      $('#paragraph-1 span').text(other_text);
      $('#paragraph-1 strong').hide();
    } else {
      $('.describe-your-condition').hide();
      $('#paragraph-1 span').text(declare_text);
    }
  });

  // Add line
  const select = document.querySelector('.disability-selector select');
  if (select && select.options.length > 0) {
    const options = Array.from(select.options);
    const targetIndex = options.findIndex(opt => opt.value === "Other");

    if (targetIndex !== -1) {
      const divider = document.createElement("option");
      divider.disabled = true;
      divider.textContent = "──────────";

      select.insertBefore(divider, select.options[targetIndex]);
    }
  }

  // Validation for custom fields and disability selector
  function validateFields() {
    let isValid = true;
    
    $('.custom-validation input').each(function () {
      let $input = $(this);
      let placeholder = $input.attr('placeholder').toLowerCase();
      let errorMessage = `<div class="messages"><div class="error">Please enter ${placeholder}</div></div>`;
      
      // Remove existing error message
      $input.closest('.custom-validation').find('.error').remove();
      
      if ($input.val().trim() === '') {
        $input.closest('.custom-validation').append(errorMessage);
        isValid = false;
      }
    });

    $('.disability-selector select').each(function () {
      let $select = $(this);
      let errorMessage = `<div class="messages"><div class="error">Please select an option</div></div>`;
      
      // Remove existing error message
      $select.closest('.disability-selector').find('.error').remove();
      
      if (!$select.val()) {
        $select.closest('.disability-selector').append(errorMessage);
        isValid = false;
      }
    });

    return isValid;
  }

  // Trigger validation on button click
  $(document).on('click', 'button.submit', function (e) {
    if (validateFields()) {
      // Allow form submission if no errors
      return true;
    } else {
      // Prevent form submission if validation errors exist
      e.preventDefault();
    }
  });
});

// Back To Top (Global)
$(document).ready(function() {
  var $backToTop = $('.back-to-top');

  // Only run script if the button exists
  if ($backToTop.length) {
    var scrollTrigger = 300; // px

    // Show/hide button based on scroll position
    $(window).on('scroll', function() {
      if ($(this).scrollTop() > scrollTrigger) {
        $backToTop.addClass('back-to-top--active');
      } else {
        $backToTop.removeClass('back-to-top--active');
      }
    });

    // Smooth scroll to top on click
    $backToTop.on('click', function(e) {
      e.preventDefault();
      $('html, body').animate({ scrollTop: 0 }, 600);
    });
  }
});

// Replace Manage At Home with non-breaking version
$(document).ready(function () {
  function replaceText(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent
        .replace(/Manage At Home/g, 'Manage\u00A0At\u00A0Home')
        .replace(/VAT Relief/g, 'VAT\u00A0Relief')
        .replace(/Incl\. VAT/g, 'Incl.\u00A0VAT');
    } else {
      node.childNodes.forEach(replaceText);
    }
  }
  replaceText(document.body);
});

// Load & play youtube when clicked
$(document).ready(function () {
  $(".responsive-video--youtube").each(function () {
    var $el = $(this);
    var videoId = $el.data("video-id").replace(/^\//, '');
    var thumbnailUrl = "https://img.youtube.com/vi/" + videoId + "/hqdefault.jpg";
    /*
    $el.css("background-image", "url(" + thumbnailUrl + ")");
    */

    $el.on("click", function () {
      stopAllVideosExcept($el);

      // Play the clicked video
      $el.addClass("responsive-video--stopped");
      var iframe = $("<iframe>", {
        src: "https://www.youtube-nocookie.com/embed/" + videoId + "?autoplay=1&rel=0",
        frameborder: 0,
        allowfullscreen: true,
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      }).css({
        width: "100%",
        height: "100%"
      });

      $el.empty().append(iframe);
    });
  });

  $(".responsive-video--vimeo").each(function () {
    var $el = $(this);
    var videoId = String($el.data("video-id") || "");
    videoId = videoId.replace(/^\//, '');
    
    // Set background using Shopify preview image
    var thumbnailUrl = $el.data("preview-image");
    if (thumbnailUrl) {
      $el.css("background-image", "url(" + thumbnailUrl + ")");
    }

    $el.on("click", function () {
      stopAllVideosExcept($el);

      // Play the clicked Vimeo video
      $el.addClass("responsive-video--stopped");
      var iframe = $("<iframe>", {
        src: "https://player.vimeo.com/video/" + videoId + "?autoplay=1&muted=0&title=0&byline=0&portrait=0",
        frameborder: 0,
        allowfullscreen: true,
        allow: "autoplay; fullscreen; picture-in-picture"
      }).css({
        width: "100%",
        height: "100%"
      });

      $el.empty().append(iframe);
    });
  });

  // When clicking .product-images__featured-item, stop all videos
  $(".product-images__featured-item").on("click", function () {
    stopAllVideosExcept(); // no argument = stop all
  });

  // Helper function to stop all other videos
  function stopAllVideosExcept($excludeEl) {
    // Youtube videos
    $(".responsive-video--youtube").each(function () {
      var $videoEl = $(this);

      // Skip the element we want to exclude from stopping
      if ($excludeEl && $videoEl.is($excludeEl)) return;

      var otherVideoId = $videoEl.data("video-id");
      $videoEl.empty(); // remove iframe
      $videoEl.css("background-image", "url(https://img.youtube.com/vi/" + otherVideoId + "/hqdefault.jpg)");
      $videoEl.removeClass("responsive-video--stopped");
    });
    // Vimeo videos
    $(".responsive-video--vimeo").each(function () {
      var $videoEl = $(this);
      if ($excludeEl && $videoEl.is($excludeEl)) return;

      var previewImage = $videoEl.data("preview-image");
      $videoEl.empty(); // remove iframe
      if (previewImage) {
        $videoEl.css("background-image", "url(" + previewImage + ")");
      }
      $videoEl.removeClass("responsive-video--stopped");
    });
  }
});


// Spec Table Tidy 
$(document).ready(function () {
  // Remove random table spaces
  $('.product-details__specs th, .product-details__specs td').each(function () {
    /*
    var text = $(this).text().replace(/\u00A0/g, '').trim();
    $(this).text(text);
    */
    $(this).contents().filter(function() {
      return this.nodeType === 3; // text nodes only
    }).each(function() {
      this.nodeValue = this.nodeValue.replace(/\u00A0/g, '').replace(/N\/A[a-zA-Z]+/g, 'N/A').trim();
    });
  });
  // Fix N/A variants inside spans within td
  $('.product-details__specs td span').each(function () {
    var updatedText = $(this).text().replace(/N\/A[a-zA-Z]+/g, 'N/A').trim();
    $(this).text(updatedText);
    var original = $(this).attr('data-original');
    if (original) {
      $(this).attr('data-original', original.replace(/N\/A[a-zA-Z]+/g, 'N/A').trim());
    }
  });

  // var $mainTable = $('.product-details__specs-table');
  // var $secondTableWrapper = $('.product-details__specs .table.table--responsive').eq(1);
  // var $secondTable = $secondTableWrapper.find('table').last();

  // if ($mainTable.length && $secondTable.length) {
  //   // Count number of columns in main table (assumes one row in thead defines it)
  //   var colCount = $mainTable.find('thead tr').first().children('td, th').length;

  //   // Adjust colspan in the second table's cells
  //   $secondTable.find('[colspan]').each(function () {
  //     var newSpan = Math.min(colCount, colCount - 1); // clamp it to total columns
  //     $(this).attr('colspan', newSpan);
  //   });

  //   // Move rows into main table
  //   var $extraTheadRows = $secondTable.find('thead tr');
  //   var $extraTbodyRows = $secondTable.find('tbody tr');

  //   $mainTable.find('thead').append($extraTheadRows);
  //   $mainTable.find('tbody').append($extraTbodyRows);

  //   $secondTable.remove();
  // }
});

// Remove empty shopify sections
$(document).ready(function () {  
  $('.shopify-section').each(function() {
    if ($(this).is(':empty') || $.trim($(this).text()) === '') {
      $(this).remove();
    }
  });
});

// Blog Categories - Show/Hide more than 10
$(document).ready(function () {
  $('.blog-category-bottom__more').off('click keydown').on('click keydown', function (event) {
    if (event.type === 'click' || event.key === 'Enter') {
      $(this).hide();
      $('.blog-category-bottom__hidden-links').slideDown(200);
    }
  });
});

// Blog Comments - Show ID in URL
$(document).ready(function() {
  $('.article-comments__comment[id]').not('.article-comments__comment--reply').on('click', function(event) {
    const elementId = $(this).attr('id');
    if (elementId) {
      const url = window.location.href.split('#')[0] + '#' + elementId;
      history.replaceState(null, '', url); // Update URL without scrolling
      event.preventDefault();
    }
  });
});

// VAT Form - Show Hide Email Field
$(document).ready(function() {
  // Check if checkbox exists
  if ($('#receive_email_checkbox').length) {
    // Initial check on page load
    if ($('#receive_email_checkbox').is(':checked')) {
      $('#hidden_email').slideDown("fast");
    } else {
      $('#hidden_email').hide(); // Keep it hidden initially
    }

    // Watch for changes
    $('#receive_email_checkbox').change(function() {
      if ($(this).is(':checked')) {
        $('#hidden_email').slideDown("fast"); 
      } else {
        $('#hidden_email').slideUp("fast");
      }
    });
  }
});

if (!customElements.get('product-intro-description')) {
  customElements.define('product-intro-description', class extends HTMLElement {
    connectedCallback() {
      if (this.expanded) return;
      this.content = this.querySelector('.product-short-description__content');
      this.button = this.querySelector('.product-short-description__expand');
      if (!this.content || !this.button) return;

      this.button.onclick = () => {
        this.expanded = true;
        this.observer.disconnect();
        this.content.classList.remove('product-short-description__content--clamped');
        this.button.setAttribute('aria-expanded', 'true');
        this.button.remove();
        this.content.focus({ preventScroll: true });
      };

      this.observer?.disconnect();
      this.observer = new ResizeObserver(() => this.updateClamp());
      this.observer.observe(this.content);
      this.updateClamp();
      document.fonts.ready.then(() => this.updateClamp());
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    updateClamp() {
      if (this.expanded || !this.isConnected || !this.content.clientHeight) return;
      const truncated = this.content.scrollHeight > this.content.clientHeight + 1;
      this.button.hidden = !truncated;
    }
  });
}

if (!customElements.get('product-section-links')) {
  customElements.define('product-section-links', class extends HTMLElement {
    connectedCallback() {
      this.scroller = this.querySelector('.product-quick-links__scroll');
      this.group = this.querySelector('.product-quick-links__group');
      if (!this.scroller || !this.group) return;

      this.updateScrollState = () => {
        if (!this.isConnected) return;
        const maxScroll = this.scroller.scrollWidth - this.scroller.clientWidth;
        const scrollLeft = Math.max(0, Math.min(this.scroller.scrollLeft, maxScroll));
        this.classList.toggle('can-scroll-left', scrollLeft > 1);
        this.classList.toggle('can-scroll-right', maxScroll - scrollLeft > 1);
      };
      this.events = new AbortController();
      const { signal } = this.events;
      this.suppressClick = false;
      this.finishDrag = (event) => {
        if (!this.drag || (event && event.pointerId !== this.drag.pointerId)) return;
        const { pointerId } = this.drag;
        this.drag = null;
        if (this.scroller.hasPointerCapture(pointerId)) this.scroller.releasePointerCapture(pointerId);
      };
      this.scroller.addEventListener('pointerdown', (event) => {
        this.suppressClick = false;
        if (event.pointerType !== 'mouse' || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
        if (this.scroller.scrollWidth <= this.scroller.clientWidth + 1) return;
        this.drag = { pointerId: event.pointerId, startX: event.clientX, scrollLeft: this.scroller.scrollLeft, moved: false };
      }, { signal });
      window.addEventListener('pointermove', (event) => {
        if (!this.drag || event.pointerId !== this.drag.pointerId) return;
        if (event.buttons === 0) {
          this.finishDrag(event);
          return;
        }
        const delta = event.clientX - this.drag.startX;
        if (!this.drag.moved && Math.abs(delta) < 6) return;
        if (!this.drag.moved) {
          this.drag.moved = true;
          this.suppressClick = true;
          this.scroller.setPointerCapture(event.pointerId);
        }
        event.preventDefault();
        this.scroller.scrollLeft = this.drag.scrollLeft - delta;
      }, { signal });
      window.addEventListener('pointerup', this.finishDrag, { signal });
      window.addEventListener('pointercancel', this.finishDrag, { signal });
      window.addEventListener('blur', () => this.finishDrag(), { signal });
      this.scroller.addEventListener('lostpointercapture', this.finishDrag, { signal });
      this.scroller.addEventListener('dragstart', (event) => event.preventDefault(), { signal });
      this.scroller.addEventListener('click', (event) => {
        if (!this.suppressClick || event.detail === 0) return;
        this.suppressClick = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, { capture: true, signal });
      this.scroller.addEventListener('scroll', this.updateScrollState, { passive: true, signal });
      this.observer = new ResizeObserver(this.updateScrollState);
      this.observer.observe(this.scroller);
      this.observer.observe(this.group);
      this.updateScrollState();
      document.fonts.ready.then(this.updateScrollState);
    }

    disconnectedCallback() {
      this.finishDrag?.();
      this.events?.abort();
      this.observer?.disconnect();
    }
  });
}

(() => {
  const itemSelector = '.product-usps--managed .product-usps__item.tool-tip__zone';
  let activeItem = null;
  let touchGesture = null;
  let touchInput = false;
  let touchScrolled = false;
  let scrollTimer;

  const closeTooltip = () => {
    activeItem?.classList.remove('is-tooltip-open');
    activeItem = null;
  };
  const openTooltip = (item) => {
    if (activeItem === item) return;
    closeTooltip();
    clearTimeout(scrollTimer);
    item.classList.add('is-tooltip-open');
    activeItem = item;
  };
  const initialise = (root) => {
    root.querySelectorAll('.product-usps').forEach(list => list.classList.add('product-usps--managed'));
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    if (activeItem && event.target.contains(activeItem)) closeTooltip();
    if (touchGesture?.item && event.target.contains(touchGesture.item)) touchGesture = null;
  });

  document.addEventListener('pointerover', (event) => {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest(itemSelector);
    if (item) openTooltip(item);
  });
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType !== 'mouse') return;
    const item = event.target.closest(itemSelector);
    if (item && item === activeItem && !item.contains(event.relatedTarget)) closeTooltip();
  });
  document.addEventListener('pointerdown', (event) => {
    touchInput = event.pointerType !== 'mouse';
    const item = event.target.closest(itemSelector);
    if (!item) closeTooltip();
    if (!touchInput) return;
    touchScrolled = false;
    touchGesture = { item, pointerId: event.pointerId, x: event.clientX, y: event.clientY, moved: false };
  }, { passive: true });
  document.addEventListener('pointermove', (event) => {
    if (!touchGesture || event.pointerId !== touchGesture.pointerId) return;
    if (Math.hypot(event.clientX - touchGesture.x, event.clientY - touchGesture.y) > 8) {
      touchGesture.moved = true;
      closeTooltip();
    }
  }, { passive: true });
  document.addEventListener('pointerup', (event) => {
    if (!touchGesture || event.pointerId !== touchGesture.pointerId) return;
    const gesture = touchGesture;
    touchGesture = null;
    if (gesture.moved || touchScrolled) {
      closeTooltip();
      return;
    }
    if (!gesture.item || event.target.closest(itemSelector) !== gesture.item || event.target.closest('.tool-tip')) return;
    if (activeItem === gesture.item) closeTooltip();
    else openTooltip(gesture.item);
  }, { passive: true });
  document.addEventListener('pointercancel', () => {
    if (!touchGesture) return;
    touchGesture = null;
    closeTooltip();
  }, { passive: true });
  document.addEventListener('touchend', () => {
    if (touchScrolled || touchGesture?.moved) closeTooltip();
  }, { passive: true });

  document.addEventListener('focusin', (event) => {
    const item = event.target.closest(itemSelector);
    if (!touchInput && item?.matches(':focus-visible')) openTooltip(item);
  });
  document.addEventListener('focusout', (event) => {
    if (activeItem && activeItem.contains(event.target) && !activeItem.contains(event.relatedTarget)) closeTooltip();
  });
  document.addEventListener('keydown', (event) => {
    touchInput = false;
    if (event.key === 'Escape') closeTooltip();
  });
  document.addEventListener('scroll', () => {
    touchScrolled = true;
    if (touchGesture) touchGesture.moved = true;
    closeTooltip();
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(closeTooltip, 150);
  }, { capture: true, passive: true });
  document.addEventListener('scrollend', () => {
    clearTimeout(scrollTimer);
    closeTooltip();
  }, { capture: true, passive: true });
})();
